/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-useless-computed-key */
export default {
	['较大']: 'Lớn hơn',
	['预设']: 'Mặc định',
	['较小']: 'Nhỏ hơn',
	['字级大小']: 'Cỡ chữ',
	['页面正在加载中']: 'Đang tải trang',
	['这可能需要几分钟的时间，请耐心等待']: 'Quá trình này có thể mất vài phút, vui lòng chờ trong giây lát',
	['您所访问的页面不存在']: 'Trang bạn truy cập không tồn tại',
	['开始对话']: 'Bắt đầu cuộc trò chuyện',
	['充值未到帐快速通道']: 'Kênh hỗ trợ nhanh tiền nạp chưa cập nhật',
	['人工客服']: 'Dịch vụ khách hàng trực tiếp',
	['已接听']: 'Đã kết nối',
	['结束对话']: 'Kết thúc cuộc trò chuyện',
	['联络人工客服']: 'Chat với nhân viên hỗ trợ',
	['重新选择智能客服']: 'Chọn lại trợ lý ảo',
	['感谢您使用本次服务，烦请拨冗补充填写调查，您宝贵的意见是我们前进的动力！']: 'Cảm ơn bạn đã sử dụng dịch vụ. Xin vui lòng dành chút thời gian điền vào bản khảo sát, ý kiến quý báu của bạn là động lực để chúng tôi phát triển',
	['您觉得此次的服务品质如何？']: 'Bạn nghĩ gì về chất lượng dịch vụ lần này?',
	['颗星']: 'Sao',
	['颗星(單數)']: 'Sao',
	['不评分']: 'Không đánh giá',
	['点选下方即可结束对话']: 'Nhấn vào bên dưới để kết thúc cuộc trò chuyện',
	['请输入您的ID']: 'Vui lòng nhập ID của bạn',
	['ID不能为空']: 'ID không được để trống',
	['说明文字']: 'Văn bản mô tả',
	['送出']: 'Gửi',
	['系统维护中']: 'Hệ thống đang bảo trì',
	['储存']: 'Lưu',
	['确认']: 'Xác nhận',
	['取消']: 'Hủy',
	['完成']: 'Hoàn thành',
	['协作']: 'Hợp tác',
	['转接']: 'Chuyển tiếp',
	['离开']: 'Rời khỏi',
	['请选择服务对象开始通话']: 'Vui lòng chọn đối tượng hỗ trợ để bắt đầu cuộc gọi',
	['请填写表单']: 'Vui lòng điền vào biểu mẫu',
	['本对话已经结束']: 'Cuộc trò chuyện này đã kết thúc',
	['客服已逾 {{second}} 秒未回应']: 'Dịch vụ khách hàng đã không phản hồi trong {{second}} giây',
	['历史对话']: 'Lịch sử trò chuyện',
	['查无资料']: 'Không tìm thấy dữ liệu',
	['标签']: 'Nhãn',
	['正在输入中...']: 'Đang nhập...',
	['于']: 'Tại',
	['档案容量限制']: 'Giới hạn dung lượng tệp',
	['不能为空']: 'Không được để trống',
	['提交']: 'Gửi đi',
	['满意度']: 'Độ hài lòng',
	['IP未知']: 'IP không xác định',
	['地区未知']: 'Khu vực không xác định',
	['使用者环境未知']: 'Môi trường người dùng không xác định',
	['关闭']: 'Đóng',
	['全萤幕截图成档案']: 'Chụp màn hình toàn màn thành tệp',
	['Mac用户']: 'Người dùng Mac',
	['Windows用户']: 'Người dùng Windows',
	['Windows键']: 'Phím Windows',
	['全萤幕截图至剪贴簿']: 'Chụp toàn màn hình vào bộ nhớ tạm',
	['截图完成后请直接于文字输入处贴上']: 'Sau khi chụp màn hình, hãy dán trực tiếp vào vị trí nhập văn bản',
	['使用Windows内建截图工具或者QQ软件截图功能，截图完成后请直接于文字输入处贴上']: 'Sử dụng công cụ chụp màn hình có sẵn của Windows hoặc QQ, sau khi chụp xong vui lòng dán trực tiếp vào khung nhập tin nhắn',
	['截图']: 'Chụp ảnh',
	['档案']: 'Tệp',
	['下载失败']: 'Tải xuống thất bại',
	['请输入分类名称']: 'Vui lòng nhập tên danh mục',
	['新增']: 'Thêm mới',
	['更新']: 'Cập nhật',
	['请选择一个分类']: 'Vui lòng chọn một danh mục',
	['请输入标题']: 'Vui lòng nhập tiêu đề',
	['请输入内文']: 'Vui lòng nhập nội dung',
	['请上传图片']: 'Vui lòng tải lên hình ảnh',
	['快捷语']: 'Cụm từ nhanh',
	['图片']: 'Hình ảnh',
	['管理分类']: 'Quản lý danh mục',
	['新增分类']: 'Thêm danh mục mới',
	['标题/内文']: 'Tiêu đề/Nội dung',
	['分类']: 'Danh mục',
	['编辑']: 'Chỉnh sửa',
	['删除']: 'Xóa',
	['平台名称']: 'Tên nền tảng',
	['显示']: 'Hiển thị',
	['编辑服务平台']: 'Chỉnh sửa nền tảng dịch vụ',
	['若有服务中的客户，无法关闭服务平台']: 'Nếu có khách hàng đang được phục vụ, không thể đóng nền tảng dịch vụ',
	['确定']: 'Đồng ý',
	['人员列表']: 'Danh sách nhân viên',
	['服务人数']: 'Số người phục vụ',
	['选择转接人员']: 'Chọn nhân viên chuyển tiếp',
	['按此上传图片']: 'Nhấp vào đây để tải ảnh lên',
	['确定要取消{{displayName}}协作邀请吗？']: 'Bạn có chắc muốn hủy lời mời hợp tác của {{-displayName}} không?',
	['确定要结束{{displayName}}的协作吗？']: 'Bạn có chắc muốn kết thúc hợp tác với {{-displayName}} không?',
	['等待协作中']: 'Chờ đợi hợp tác',
	['协作中']: 'Đang hợp tác',
	['负责人']: 'Người phụ trách',
	['已选择']: 'Đã chọn',
	['可协作人数已满']: 'Số lượng người có thể hợp tác là đầy đủ',
	['选择协作人员']: 'Chọn nhân viên hợp tác',
	['提示']: 'Thông báo',
	['请输入讯息']: 'Vui lòng nhập tin nhắn',
	['确定已經完成？']: 'Bạn đã hoàn thành chưa?',
	['常用图片']: 'Hình ảnh thường dùng',
	['用户']: 'Người dùng',
	['个人']: 'Cá nhân',
	['公共']: 'Công cộng',
	['开始谈话']: 'Bắt đầu cuộc trò chuyện',
	['等待中']: 'Đang chờ',
	['客户已离开对话']: 'Khách hàng đã rời khỏi cuộc trò chuyện',
	['正在转接给']: 'Đang chuyển tiếp cho',
	['邀请你加入协作']: 'Mời bạn tham gia hợp tác',
	['请求转接']: 'Yêu cầu chuyển tiếp',
	['正在服务中']: 'Đang phục vụ',
	['编辑平台']: 'Chỉnh sửa nền tảng',
	['您的连线已中断']: 'Kết nối của bạn đã bị ngắt',
	['正尝试重新连线']: 'Đang cố gắng kết nối lại',
	['重新登入']: 'Đăng nhập lại',
	['请先登入']: 'Vui lòng đăng nhập trước',
	['帐号']: 'Tài khoản',
	['帐号不能为空']: 'Tài khoản không được để trống',
	['请输入帐号']: 'Vui lòng nhập tài khoản',
	['密码']: 'Mật khẩu',
	['密码不能为空']: 'Mật khẩu không được để trống',
	['请输入密码']: 'Vui lòng nhập mật khẩu',
	['登录']: 'Đăng nhập',
	['客服系统客服端']: 'Hệ thống dịch vụ khách hàng',
	['平台异动，请重新整理']: 'Nền tảng có sự thay đổi, vui lòng làm mới lại',
	['客服系统升级维护中，请您晚点再联系线上客服，谢谢']: 'Hệ thống dịch vụ khách hàng đang được nâng cấp và bảo trì, vui lòng liên hệ với bộ phận chăm sóc khách hàng trực tuyến sau, xin cảm ơn',
	['客服系统进入升级维护作业，很抱歉中断您的对话，请您晚点再联系线上客服']: 'Hệ thống dịch vụ khách hàng đã đi vào hoạt động nâng cấp và bảo trì. Tôi rất tiếc đã làm gián đoạn cuộc trò chuyện của bạn. Vui lòng liên hệ với bộ phận dịch vụ khách hàng trực tuyến sau.',
	['请稍后再试']: 'Vui lòng thử lại sau',
	['是']: 'Có',
	['否']: 'Không',
	['等于']: 'Bằng',
	['包含']: 'Bao gồm',
	['排除']: 'Loại trừ',
	['大于']: 'Lớn hơn',
	['少于']: 'Nhỏ hơn',
	['数量区间']: 'Khoảng số lượng',
	['客服对话数']: 'Số cuộc trò chuyện của dịch vụ khách hàng',
	['客戶对话数']: 'Số cuộc trò chuyện của khách hàng',
	['即时资讯']: 'Thông tin tức thời',
	['报表分析']: 'Phân tích báo cáo',
	['平均通话时间']: 'Thời gian trò chuyện trung bình',
	['回覆通话数']: 'Số lần phản hồi cuộc gọi',
	['平均等待时间']: 'Thời gian chờ trung bình',
	['客户满意度']: 'Độ hài lòng của khách hàng',
	['历史对话记录']: 'Lịch sử trò chuyện',
	['操作日志']: 'Nhật ký hoạt động',
	['智能客服设定']: 'Thiết lập dịch vụ khách hàng thông minh',
	['机器人设定']: 'Thiết lập robot',
	['版本管理']: 'Quản lý phiên bản',
	['档案总览']: 'Tổng quan tệp',
	['设定']: 'Thiết lập',
	['公司管理']: 'Quản lý công ty',
	['维修管理']: 'Quản lý bảo trì',
	['一般设定']: 'Thiết lập chung',
	['公告管理']: 'Quản lý thông báo',
	['帐号管理']: 'Quản lý tài khoản',
	['平台管理']: 'Quản lý nền tảng',
	['角色管理']: 'Quản lý vai trò',
	['团队管理']: 'Quản lý đội',
	['标签管理']: 'Quản lý nhãn',
	['查询']: 'Truy vấn',
	['重置']: 'Đặt lại',
	['今天']: 'Hôm nay',
	['昨天']: 'Hôm qua',
	['过去7天']: '7 ngày qua',
	['过去10天']: '10 ngày qua',
	['过去一个月']: 'Một tháng qua',
	['过去90天']: '90 ngày qua',
	['LOGO 预览']: 'Xem trước LOGO',
	['档案格式：PNG、JPG，长宽不超过']: 'Định dạng tệp: PNG, JPG, kích thước không vượt quá',
	['档案太大或格式不支援']: 'Tệp quá lớn hoặc định dạng không được hỗ trợ',
	['且档案大小不得大于']: 'Và kích thước tệp không được lớn hơn',
	['上传档案']: 'Tải tệp lên',
	['新增IP白名单成功']: 'Thêm vào danh sách trắng IP thành công',
	['删除IP白名单成功']: 'Xóa khỏi danh sách trắng IP thành công',
	['请输入欲查询的IP']: 'Vui lòng nhập IP muốn truy vấn',
	['请输入IP']: 'Vui lòng nhập IP',
	['备注']: 'Ghi chú',
	['备注不能为空']: 'Ghi chú không được để trống',
	['请输入备注']: 'Vui lòng nhập ghi chú',
	['新增时间']: 'Thời gian thêm mới',
	['操作']: 'Thao tác',
	['IP白名单']: 'Danh sách trắng IP',
	['新增IP']: 'Thêm IP',
	['新增IP白名单']: 'Thêm vào danh sách trắng IP',
	['确定删除此IP?']: 'Bạn có chắc muốn xóa IP này không?',
	['平台']: 'Nền tảng',
	['团队']: 'Đội',
	['全体']: 'Tất cả',
	['客服']: 'Dịch vụ khách hàng',
	['客服系统']: 'Hệ thống dịch vụ khách hàng',
	['个人帐号设定']: 'Thiết lập tài khoản cá nhân',
	['最少6码']: 'Ít nhất 6 ký tự',
	['最多20码']: 'Tối đa 20 ký tự',
	['不能有空白']: 'Không được có khoảng trắng',
	['应至少包含1个英文和数字']: 'Phải chứa ít nhất một chữ cái và số',
	['公司名称']: 'Tên công ty',
	['僅能输入英文和数字']: 'Chỉ được nhập chữ và số',
	['应至少包含1个英文']: 'Phải chứa ít nhất một chữ cái',
	['最少5码']: 'Ít nhất 5 ký tự',
	['IP不能为空']: 'IP không được để trống',
	['非IP位址']: 'Không phải địa chỉ IP',
	['最多500个字']: 'Tối đa 500 từ',
	['启用']: 'Kích hoạt',
	['禁用']: 'Vô hiệu hóa',
	['对话量']: 'Lượng cuộc trò chuyện',
	['目前客户数']: 'Số lượng khách hàng hiện tại',
	['目前客服数']: 'Số lượng nhân viên dịch vụ khách hàng hiện tại',
	['接通对话量']: 'Lượng cuộc trò chuyện đã kết nối',
	['全部']: 'Tất cả',
	['最近一天']: 'Một ngày gần đây',
	['最近一周']: 'Một tuần gần đây',
	['最近一月']: 'Một tháng gần đây',
	['新增过滤器']: 'Thêm bộ lọc',
	['请输入模組名称']: 'Vui lòng nhập tên mô-đun',
	['储存过滤模組']: 'Lưu bộ lọc mô-đun',
	['读取过滤模組']: 'Tải bộ lọc mô-đun',
	['确定要删除模組']: 'Bạn có chắc muốn xóa mô-đun này không?',
	['分钟']: 'Phút',
	['接通时间']: 'Thời gian kết nối',
	['通话时间']: 'Thời gian cuộc gọi',
	['请选择或输入时间']: 'Vui lòng chọn hoặc nhập thời gian',
	['等待时间']: 'Thời gian chờ',
	['对话搜寻']: 'Tìm kiếm cuộc trò chuyện',
	['请输入对话']: 'Vui lòng nhập cuộc trò chuyện',
	['客戶 ID']: 'ID khách hàng',
	['请输入客戶ID']: 'Vui lòng nhập ID khách hàng',
	['对话浏览模式']: 'Chế độ xem cuộc trò chuyện',
	['筆']: 'Bút',
	['客服本名']: 'Tên thật của nhân viên dịch vụ',
	['进入时间']: 'Thời gian vào',
	['客服昵称']: 'Biệt danh nhân viên dịch vụ',
	['客服系统管理端']: 'Quản trị hệ thống dịch vụ khách hàng',
	['数量']: 'Số lượng',
	['尚未上传档案']: 'Chưa tải lên tệp',
	['输入文字']: 'Nhập văn bản',
	['请在此输入文字']: 'Vui lòng nhập văn bản vào đây',
	['添加项目']: 'Thêm mục',
	['请选择']: 'Vui lòng chọn',
	['新增文字']: 'Thêm văn bản',
	['新增档案']: 'Thêm tệp',
	['選項']: 'Tùy chọn',
	['勾选标题']: 'Tiêu đề đánh dấu',
	['文字內容不能为空']: 'Nội dung văn bản không được để trống',
	['添加']: 'Thêm',
	['上传标题']: 'Tải tiêu đề',
	['单选标题']: 'Tiêu đề lựa chọn đơn',
	['输入框标题']: 'Tiêu đề hộp nhập liệu',
	['请输入']: 'Vui lòng nhập',
	['输入框']: 'Hộp nhập liệu',
	['单选']: 'Lựa chọn đơn',
	['核取方块']: 'Hộp kiểm',
	['请选择一个标签']: 'Vui lòng chọn một nhãn',
	['确定要删除此项目和其所有子项目？']: 'Bạn có chắc muốn xóa mục này và tất cả các mục con của nó không?',
	['答案']: 'câu trả lời',
	['表单']: 'Hình thức',
	['清除此阶层设定']: 'Xóa cài đặt tầng này',
	['请输入此阶层问题']: 'Vui lòng nhập câu hỏi cho tầng này',
	['新增选项']: 'Thêm tùy chọn',
	['新增表单']: 'Thêm biểu mẫu',
	['新增答案']: 'Thêm câu trả lời',
	['新增充值表单']: 'Thêm biểu mẫu nạp tiền',
	['若切换种类后, 将清除原有的和其子项目资料']: 'Nếu chuyển đổi loại, sẽ xóa tất cả dữ liệu và các mục con hiện có',
	['确定要清除所有资料和其子项目资料？']: 'Bạn có chắc muốn xóa tất cả dữ liệu và các mục con của nó không?',
	['阶层']: 'Tầng',
	['开场语']: 'Lời mở đầu',
	['开场语不能为空']: 'Lời mở đầu không được để trống',
	['结尾感谢语']: 'Lời cảm ơn cuối cùng',
	['结尾感谢语不能为空']: 'Lời cảm ơn cuối cùng không được để trống',
	['发布']: 'Phát hành',
	['复制']: 'Sao chép',
	['选择目的平台']: 'Chọn nền tảng đích',
	['确定复制到']: 'Xác định sao chép đến',
	['是否要正式发布到使用环境？']: 'Bạn có muốn phát hành chính thức vào môi trường sử dụng không?',
	['储存版本']: 'Lưu phiên bản',
	['版本名称']: 'Tên phiên bản',
	['请输入版本名称']: 'Vui lòng nhập tên phiên bản',
	['确定是否储存此版本']: 'Xác định có lưu phiên bản này không',
	['版本储存成功']: 'Lưu phiên bản thành công',
	['最多10个字']: 'Tối đa 10 từ',
	['公告一']: 'Thông báo một',
	['公告二']: 'Thông báo hai',
	['公告三']: 'Thông báo ba',
	['公告储存成功']: 'Lưu thông báo thành công',
	['标题']: 'Tiêu đề',
	['內文']: 'Nội dung',
	['修改登入密码']: 'Thay đổi mật khẩu đăng nhập',
	['修改基本资讯']: 'Thay đổi thông tin cơ bản',
	['昵称']: 'Biệt danh',
	['昵称不能为空']: 'Biệt danh không được để trống',
	['请输入昵称']: 'Vui lòng nhập biệt danh',
	['本名']: 'Tên thật',
	['本名不能为空']: 'Tên thật không được để trống',
	['请输入本名']: 'Vui lòng nhập tên thật',
	['选择图像']: 'Chọn hình ảnh',
	['状态']: 'Trạng thái',
	['平台代码']: 'Mã nền tảng',
	['平台代码不能为空']: 'Mã nền tảng không được để trống',
	['使用ID模式登入']: 'Đăng nhập bằng chế độ ID',
	['新增平台']: 'Thêm nền tảng',
	['修改平台']: 'Chỉnh sửa nền tảng',
	['确定重新产生Key/IV?']: 'Bạn có chắc muốn tạo lại Key/IV không?',
	['进入公司成功']: 'Vào công ty thành công',
	['确定禁用公司?']: 'Bạn có chắc muốn vô hiệu hóa công ty không?',
	['确定启用公司?']: 'Bạn có chắc muốn kích hoạt công ty không?',
	['修改公司']: 'Chỉnh sửa công ty',
	['进入公司']: 'Vào công ty',
	['确定进入公司?']: 'Bạn có chắc muốn vào công ty không?',
	['新增标签']: 'Thêm nhãn',
	['代号']: 'Mã số',
	['代号不可为空']: 'Mã số không được để trống',
	['名称']: 'Tên',
	['名称不可为空']: 'Tên không được để trống',
	['颜色']: 'Màu sắc',
	['颜色不可为空']: 'Màu sắc không được để trống',
	['进入标签']: 'Vào nhãn',
	['修改标签']: 'Chỉnh sửa nhãn',
	['确定开启进入标签?']: 'Bạn có chắc muốn kích hoạt nhãn không?',
	['确定关闭进入标签?']: 'Bạn có chắc muốn tắt nhãn không?',
	['确定删除此标签?']: 'Bạn có chắc muốn xóa nhãn này không?',
	['标签创建成功']: 'Nhãn được tạo thành công',
	['标签更新成功']: 'Nhãn được cập nhật thành công',
	['进入标签更新成功']: 'Nhãn được cập nhật thành công',
	['标签删除成功']: 'Nhãn được xóa thành công',
	['请输入代号、名称等关键字']: 'Vui lòng nhập mã số, tên và các từ khóa khác',
	['设定开场白成功']: 'Thiết lập lời mở đầu thành công',
	['客戶进入开场白']: 'Khách hàng vào lời mở đầu',
	['客戶进入开场白不可为空']: 'Khách hàng vào lời mở đầu không được để trống',
	['第一次通知时间']: 'Thời gian thông báo lần đầu',
	['第{{count}}次通知时间']: 'Thời gian thông báo lần thứ {{count}}',
	['设置错误']: 'Lỗi cài đặt',
	['设定等待过长通知时间成功']: 'Thiết lập thời gian chờ thông báo thành công',
	['秒']: 'Giây',
	['对话自动断开时间']: 'Thời gian tự động ngắt cuộc trò chuyện',
	['未发话时间']: 'Thời gian không phát biểu',
	['未发话提示文字']: 'Văn bản nhắc nhở khi không phát biểu',
	['设定对话断开成功']: 'Thiết lập ngắt cuộc trò chuyện thành công',
	['Favicon预览']: 'Xem trước Favicon',
	['更换 Favicon 成功']: 'Thay đổi Favicon thành công',
	['档案格式：ICO，長寬不超過 32x32 px']: 'Định dạng tệp: ICO, kích thước không vượt quá 32x32 px',
	['更换 LOGO 成功']: 'Thay đổi LOGO thành công',
	['智能客服']: 'Trợ lý ảo',
	['设定通道成功']: 'Thiết lập kênh thành công',
	['设定提示音效成功']: 'Thiết lập âm thanh nhắc nhở thành công',
	['单音']: 'Âm đơn',
	['循环音']: 'Âm lặp',
	['编号']: 'Số hiệu',
	['资料类型']: 'Loại dữ liệu',
	['资料类型不可为空']: 'Loại dữ liệu không được để trống',
	['数字']: 'Số',
	['字串']: 'Chuỗi',
	['布林']: 'Boolean',
	['建立标签成功']: 'Tạo nhãn thành công',
	['修改标签成功']: 'Chỉnh sửa nhãn thành công',
	['删除标签成功']: 'Xóa nhãn thành công',
	['更换 LOGO']: 'Thay đổi LOGO',
	['更换 Favicon']: 'Thay đổi Favicon',
	['对话断开']: 'Ngắt cuộc trò chuyện',
	['等待过长通知时间']: 'Thời gian thông báo chờ quá lâu',
	['开场白']: 'Lời mở đầu',
	['提示音效设定']: 'Thiết lập âm thanh nhắc nhở',
	['通道设定']: 'Thiết lập kênh',
	['自定义标签']: 'Tạo nhãn tùy chỉnh',
	['开启维修模式将会停止客服系统运作。确定要开启嗎？']: 'Kích hoạt chế độ bảo trì sẽ ngừng hoạt động của hệ thống dịch vụ khách hàng. Bạn có chắc muốn kích hoạt không?',
	['关闭维修模式，客服系统将会继续运作。确定要关闭嗎？']: 'Tắt chế độ bảo trì, hệ thống dịch vụ khách hàng sẽ tiếp tục hoạt động. Bạn có chắc muốn tắt không?',
	['状态更新成功']: 'Cập nhật trạng thái thành công',
	['通知讯息更新成功']: 'Cập nhật thông báo thành công',
	['维修模式']: 'Chế độ bảo trì',
	['通知讯息设定']: 'Thiết lập thông báo',
	['尚未连线状态']: 'Trạng thái chưa kết nối',
	['尚未连线状态描述']: 'Mô tả trạng thái chưa kết nối',
	['已连线状态']: 'Trạng thái đã kết nối',
	['已连线状态描述']: 'Mô tả trạng thái đã kết nối',
	['开启成功']: 'Mở thành công',
	['关闭成功']: 'Đóng thành công',
	['关闭登入管理模式将会限制客戶藉由输入ID 进入客服，确定要关闭嗎？(若沒有提供客戶Profile资料则会进入错误页面)']: 'Đóng chế độ quản lý đăng nhập sẽ hạn chế khách hàng truy cập vào dịch vụ khách hàng bằng cách nhập ID, bạn có chắc muốn đóng không? (Nếu không cung cấp thông tin hồ sơ khách hàng sẽ dẫn đến trang lỗi)',
	['开启登入管理模式将会開放客戶藉由输入 ID 进入客服，确定要开启嗎？']: 'Mở chế độ quản lý đăng nhập sẽ cho phép khách hàng truy cập vào dịch vụ khách hàng bằng cách nhập ID, bạn có chắc muốn mở không?',
	['请输入帐号、昵称、角色等关键字']: 'Vui lòng nhập tài khoản, biệt danh, vai trò và các từ khóa khác',
	['新增角色']: 'Thêm vai trò',
	['修改角色']: 'Chỉnh sửa vai trò',
	['角色创建成功']: 'Tạo vai trò thành công',
	['角色更新成功']: 'Cập nhật vai trò thành công',
	['角色删除成功']: 'Xóa vai trò thành công',
	['请输入角色名称，平台，权限等关键字']: 'Vui lòng nhập tên vai trò, nền tảng, quyền hạn và các từ khóa khác',
	['关键字']: 'Từ khóa',
	['角色名称']: 'Tên vai trò',
	['角色名称不可为空']: 'Tên vai trò không được để trống',
	['请输入角色名称']: 'Vui lòng nhập tên vai trò',
	['上级角色']: 'Vai trò cấp trên',
	['上级角色不可为空']: 'Vai trò cấp trên không được để trống',
	['权限']: 'Quyền hạn',
	['确定删除此角色?']: 'Bạn có chắc muốn xóa vai trò này không?',
	['图像不能为空']: 'Hình ảnh không được để trống',
	['新增团队']: 'Thêm đội',
	['修改团队']: 'Chỉnh sửa đội',
	['团队创建成功']: 'Tạo đội thành công',
	['团队修改成功']: 'Chỉnh sửa đội thành công',
	['团队删除成功']: 'Xóa đội thành công',
	['人数']: 'Số lượng',
	['新登入密码']: 'Mật khẩu đăng nhập mới',
	['新密码不能设定與舊密码相同']: 'Mật khẩu mới không được giống mật khẩu cũ',
	['新密码與確認密码不相同']: 'Mật khẩu mới và mật khẩu xác nhận không giống nhau',
	['确定修改登入密码?']: 'Bạn có chắc muốn thay đổi mật khẩu đăng nhập không?',
	['登入密码修改成功，请重新登入']: 'Thay đổi mật khẩu đăng nhập thành công, vui lòng đăng nhập lại',
	['个人资讯']: 'Thông tin cá nhân',
	['搜寻快捷语']: 'Tìm kiếm cụm từ nhanh',
	['登出']: 'Đăng xuất',
	['帐密错误']: 'Lỗi bí mật tài khoản',
	['一']: 'Một',
	['二']: 'Hai',
	['三']: 'Ba',
	['四']: 'Bốn',
	['五']: 'Năm',
	['六']: 'Sáu',
	['七']: 'Bảy',
	['请输入客服本名、客服昵称等关键字']: 'Vui lòng nhập tên thật của nhân viên dịch vụ, biệt danh và các từ khóa khác',
	['共 {{count}} 筆资料']: 'Tổng cộng {{count}} dữ liệu',
	['平台语言不能为空']: 'Ngôn ngữ nền tảng không được để trống',
	['开启']: 'Mở',
	['语言']: 'Ngôn ngữ',
	['切换语言']: 'Chuyển đổi ngôn ngữ',
	['语言名称']: 'Tên ngôn ngữ',
	['系统设定']: 'Cài đặt hệ thống',
	['储存成功']: 'Lưu thành công',
	['发布成功']: 'Phát hành thành công',
	['复制成功']: 'Sao chép thành công',
	['项目选取']: 'Chọn dự án',
	['图像']: 'Hình ảnh',
	['角色']: 'Vai trò',
	['新增帐号']: 'Thêm tài khoản',
	['角色不能为空']: 'Vai trò không được để trống',
	['登入密码']: 'Mật khẩu đăng nhập',
	['请输入代号、名称、备注等关键字']: 'Vui lòng nhập mã số, tên và ghi chú và các từ khóa khác',
	['确定删除此团队?']: 'Bạn có chắc muốn xóa đội này không?',
	['切换语言成功']: 'Chuyển đổi ngôn ngữ thành công',
	['确定要切换语言?']: 'Bạn có chắc muốn chuyển đổi ngôn ngữ không?',
	['选项']: 'Tùy chọn',
	['选择语言']: 'Chọn ngôn ngữ',
	['修改成功']: 'Chỉnh sửa thành công',
	['舊登入密码']: 'Mật khẩu đăng nhập cũ',
	['確認新登入密码']: 'Xác nhận mật khẩu đăng nhập mới',
	['语言切换成功，將重整页面以套用更新']: 'Chuyển đổi ngôn ngữ thành công, trang sẽ được tải lại để áp dụng cập nhật',
	['笔 / 页']: 'Bút / trang',
	['时段搜寻']: 'Tìm kiếm theo khoảng thời gian',
	['请选择时段']: 'Vui lòng chọn khoảng thời gian',
	['更换背景色']: 'Thay đổi màu nền',
	['设定背景颜色成功']: 'Thiết lập màu nền thành công',
	['请重新登入']: 'Vui lòng đăng nhập lại',
	['绑定谷歌验证']: 'Liên kết xác minh Google',
	['解除绑定']: 'Hủy liên kết',
	['谷歌验证状态']: 'Trạng thái xác minh Google',
	['已绑定']: 'Đã liên kết',
	['未绑定']: 'Chưa liên kết',
	['解绑谷歌验证失败']: 'Không hủy liên kết xác thực Google được',
	['二维码方式添加']: 'Thêm bằng mã QR',
	['请在 Google 身份验证器中采用添加条形码方式添加']: 'Vui lòng thêm mã vạch vào Google Authenticator',
	['密钥方式添加']: 'Thêm bằng khóa bí mật',
	['请在 Google 身份验证器中采用输入提供的密钥方式添加']: 'Vui lòng nhập khóa bí mật được cung cấp vào Google Authenticator',
	['密钥如下所示']: 'Khóa bí mật như sau',
	['请再次输入登入密码']: 'Vui lòng nhập lại mật khẩu đăng nhập',
	['谷歌6位动态密码']: 'Mật khẩu động 6 chữ số của Google',
	['请绑定谷歌验证']: 'Vui lòng liên kết xác minh Google',
	['谷歌验证绑定成功']: 'Liên kết xác minh Google thành công',
	['解绑谷歌验证成功']: 'Hủy liên kết xác minh Google thành công',
	['确定解绑谷歌验证？']: 'Bạn có chắc muốn hủy liên kết xác minh Google không?',
	['请输入谷歌动态码']: 'Vui lòng nhập mã động của Google',
	['谷歌动态码']: 'Mã động của Google',
	['谷歌动态码不能为空']: 'Mã động của Google không được để trống',
	['谷歌动态码长度6码']: 'Mã động của Google phải có 6 chữ số',
	['谷歌动态码错误']: 'Mã động của Google không chính xác',
	['內容']: 'Nội dung',
	['搜寻']: 'Tìm kiếm',
	['连线中断，点击“确定”即重新连线客服。']: 'Kết nối bị gián đoạn, nhấp vào "Xác nhận" để kết nối lại dịch vụ khách hàng.',
	['充值表单']: 'Hình thức nạp tiền',
	['网银充值']: 'Nạp tiền qua ngân hàng trực tuyến',
	['扫码充值']: 'Quét mã để nạp tiền',
	['带入目前帐号']: 'Sử dụng tài khoản hiện tại',
	['自行输入平台帐号']: 'Nhập tài khoản nền tảng',
	['充值方式']: 'Phương thức nạp tiền',
	['平台帐号']: 'Tài khoản nền tảng',
	['充值金额']: 'Số tiền nạp',
	['付款人姓名']: 'Họ tên người chuyển tiền',
	['确认语']: 'Câu xác nhận',
	['操作时间']: 'Thời gian thực hiện',
	['操作者']: 'Người thực hiện',
	['请输入备注等关键字']: 'Vui lòng nhập ghi chú và các từ khóa khác',
	['操作类型']: 'Loại hành động',
	['修改平台昵称']: 'Thay đổi biệt danh nền tảng',
	['修改平台昵称成功']: 'Thay đổi biệt danh nền tảng thành công',
	['输入格式错误']: 'Lỗi định dạng đầu vào',
	['套用']: 'Áp dụng',
	['确定套用到']: 'Xác nhận áp dụng cho',
	['套用成功']: 'Áp dụng thành công',
	['储存方式']: 'Phương thức lưu trữ',
	['储存時間']: 'Thời gian lưu trữ',
	['系统发布']: 'Phát hành hệ thống',
	['手动储存']: 'Lưu trữ thủ công',
	['自动储存']: 'Lưu trữ tự động',
	['预览']: 'Xem trước',
	['最多350个字']: 'Tối đa 350 từ',
	['修改']: 'Chỉnh sửa',
	['共同资讯管理']: 'Quản lý thông tin chung',
	['共同资讯创建成功']: 'Tạo thông tin chung thành công',
	['共同资讯修改成功']: 'Chỉnh sửa thông tin chung thành công',
	['新增共同资讯']: 'Thêm thông tin chung',
	['修改共同资讯']: 'Chỉnh sửa thông tin chung',
	['删除成功']: 'Xóa thành công',
	['已设置于其他答案，无法删除']: 'Nó đã được đặt trong các câu trả lời khác và không thể bị xóa',
	['请输入名称、内容等关键字']: 'Vui lòng nhập tên, nội dung và các từ khóa khác',
	['确定删除此共同资讯？']: 'Bạn có chắc muốn xóa thông tin chung này không?',
	['共同资讯']: 'Thông tin chung',
	['尚未选择共同资讯']: 'Chưa chọn thông tin chung',
	['选择共同资讯']: 'Chọn thông tin chung',
	['选择']: 'Chọn',
	['点击「确定」后，即覆盖该平台的快捷语设定']: 'Sau khi nhấp vào "Xác nhận", sẽ thay thế cài đặt cụm từ nhanh của nền tảng này',
	['已复制：目的平台']: 'Đã sao chép: Nền tảng đích',
	['是否离开客服系统？']: 'Bạn có muốn rời khỏi hệ thống hỗ trợ không?',
	['感谢您的作答，此次评分为：{{score}}分']: 'Cảm ơn đánh giá của bạn, điểm số lần này là: {{score}}',
	['共 {{count}} 筆']: 'Tổng số {{count}} dữ liệu',
	['分']: 'Điểm',
	['新增公司']: 'Thêm công ty',
	['翻译']: 'Dịch',
	['显示原文']: 'Hiển thị văn bản gốc',
	['解绑谷歌验证']: 'Hủy liên kết xác minh Google',
	['请输入名称 内容等关键字']: 'Vui lòng nhập tên, nội dung và các từ khóa khác',
	['表单选项']: 'Tùy chọn biểu mẫu',
	['年']: 'Năm',
	['等待时间颜色设定']: 'Thiết lập màu thời gian chờ',
	['显示颜色']: 'Hiển thị màu',
	['确认删除此规则?']: 'Bạn có chắc muốn xóa quy tắc này không?',
	['页签']: 'Tab',
	['超过 {{time}} 分钟']: 'Vượt quá {{-time}} phút',
	['新增成功']: 'Thêm thành công',
	['删除完成']: 'Xóa hoàn tất',
	['等待时间(分钟)']: 'Thời gian chờ (phút)',
	['时间']: 'Thời gian',
	['不可为空']: 'Không được để trống',
	['需为正整数']: 'Phải là số nguyên dương',
	['按平台名称排列(A-Z)']: 'Sắp xếp theo tên nền tảng (A-Z)',
	['按平台名称排列(Z-A)']: 'Sắp xếp theo tên nền tảng (Z-A)',
	['旧版面模式']: 'Chế độ giao diện cũ',
	['自动翻译']: 'Dịch tự động',
	['功能設定']: 'Cài đặt chức năng',
	['确认切换版面？']: 'Bạn có chắc muốn chuyển đổi giao diện không?',
	['确认开启自动翻译？']: 'Bạn có chắc muốn bật dịch tự động không?',
	['确认关闭自动翻译？']: 'Bạn có chắc muốn tắt dịch tự động không?',
	['原文']: 'Văn bản gốc',
	['泰语']: 'Tiếng Thái',
	['追踪']: 'Theo dõi',
	['取消追踪']: 'Hủy theo dõi',
	['预览影片']: 'Xem trước video',
	['仅能上传 MP4、MOV、 JPEG (JPG)、PNG、 GIF、HEIC、RAW、HEIF档案']: 'Chỉ có thể tải lên các tệp MP4, MOV, JPEG (JPG), PNG, GIF, HEIC, RAW, HEIF',
	['请勿输入语法相关字串']: 'Vui lòng không nhập chuỗi ký tự mã lệnh',
	['输入名称']: 'Nhập tên',
	['设为预设版本']: 'Đặt làm phiên bản mặc định',
	['另存为新版本']: 'Lưu thành phiên bản mới',
	['请选择版本']: 'Vui lòng chọn phiên bản',
	['一键开关']: 'Chuyển đổi nhanh',
	['若有服务中的客户，无法关闭服务平台与切换版本']: 'Nếu có khách hàng đang được phục vụ, không thể đóng nền tảng dịch vụ hoặc chuyển đổi phiên bản',
	['是否确认要覆盖已有的设定，储存新的设定？']: 'Bạn có chắc muốn ghi đè cài đặt hiện có và lưu cài đặt mới không?',
	['已储存超过五个版本']: 'Đã lưu trữ hơn năm phiên bản',
	['版本已变动，是否需要储存？']: 'Phiên bản đã thay đổi, bạn có cần lưu không?',
	['确定删除此版本？']: 'Bạn có chắc muốn xóa phiên bản này không?',
	['编辑版本']: 'Chỉnh sửa phiên bản',
	['侦测到重复联系客服系统，若非您本人请告知客服']: 'Phát hiện kết nối trùng lặp với hệ thống CSKH, nếu không phải là bạn, vui lòng thông báo cho nhân viên hỗ trợ',
	['删除此版本']: 'Xóa phiên bản này',
	['刪除成功']: 'Xóa thành công',
	['刪除失敗']: 'Xóa thất bại',
	['儲存成功']: 'Lưu thành công',
	['儲存失敗']: 'Lưu thất bại',
	['您好，请问要选择哪个问题？']: 'Xin chào, bạn muốn chọn câu hỏi nào?',
	['等待服务区']: 'Khu vực chờ dịch vụ',
	['按时间排列(長到短)']: 'Sắp xếp theo thời gian (dài đến ngắn)',
	['按时间排列(短到長)']: 'Sắp xếp theo thời gian (ngắn đến dài)',
	['亲, 欢迎您的到来～很高兴为您服务，请先别著急，我们即将为您提供服务 ...']: 'Xin chào, rất vui được phục vụ bạn! Xin bạn chờ trong giây lát, chúng tôi sẽ sớm hỗ trợ bạn ngay',
	['编辑标签']: 'Chỉnh sửa nhãn',
	['于 {{time}} 侦测到会员【稍早已离线】']: 'Phát hiện thành viên đã ngoại tuyến vào {{-time}}',
	['{{score}}分']: '{{score}} điểm',
	['未评分']: 'Chưa đánh giá',
	['客服完成']: 'Hoàn thành dịch vụ khách hàng',
	['会员离线']: 'Thành viên ngoại tuyến',
	['超时自动断线']: 'Ngắt kết nối tự động do quá giờ',
	['{{text}}不可重复']: '{{-text}} không được trùng lặp',
	['{{text}}不能为空']: '{{-text}} không được để trống',
	['{{text}}设置错误']: 'Lỗi cài đặt {{-text}}',
	['平均通话时长']: 'Thời lượng cuộc gọi trung bình',
	['平均通话数']: 'Số cuộc gọi trung bình',
	['请选择角色名称']: 'Vui lòng chọn tên vai trò',
	['请选择客服']: 'Vui lòng chọn dịch vụ khách hàng',
	['请选择团队']: 'Vui lòng chọn đội',
	['播放']: 'Phát',
	['统计时间']: 'Thời gian thống kê',
	['统计时间不可为空']: 'Thời gian thống kê không được để trống',
	['请输入时间']: 'Vui lòng nhập thời gian',
	['时间筛选']: 'Lọc theo thời gian',
	['汇出']: 'Xuất',
	['未出勤']: 'Không có mặt',
	['客服平均通话时长']: 'Thời lượng cuộc gọi trung bình của dịch vụ khách hàng',
	['数量筛选']: 'Lọc theo số lượng',
	['客服平均等待时间']: 'Thời gian chờ trung bình của dịch vụ khách hàng',
	['上一个月']: 'Tháng trước',
	['导出Excel成功']: 'Xuất Excel thành công',
	['对话结束']: 'Kết thúc trò chuyện',
	['满意度/客服']: 'Độ hài lòng/Khách hàng',
	['日期/客服']: 'Ngày/Khách hàng',
	['总数']: 'Tổng số',
	['日平均']: 'Trung bình hàng ngày',
	['客服日均量']: 'Lượng trung bình hàng ngày của khách hàng',
	['客服通话总量']: 'Tổng số cuộc gọi của khách hàng',
	['日总量']: 'Tổng số hàng ngày',
	['请输入数量']: 'Vui lòng nhập số lượng',
	['满意度预设分数']: 'Điểm độ hài lòng mặc định',
	['当会员未评分，会自动给予此预设分数。']: 'Khi thành viên không đánh giá, điểm mặc định này sẽ được tự động cấp.',
	['设定满意度预设分数成功']: 'Thiết lập điểm độ hài lòng mặc định thành công',
	['客户满意度管理']: 'Quản lý độ hài lòng khách hàng',
	['对话结束方式']: 'Cách kết thúc cuộc trò chuyện',
	['对话满意度']: 'Độ hài lòng cuộc trò chuyện',
	['时段']: 'Khoảng thời gian',
	['客服平均满意度']: 'Độ hài lòng trung bình của khách hàng',
	['公用设定']: 'Cài đặt chung',
	['通话时长']: 'Thời gian cuộc gọi',
	['服务时段']: 'Khoảng thời gian dịch vụ',
	['储存时间']: 'Thời gian lưu trữ',
	['客服不可为空']: 'Không được để trống khách hàng',
	['团队不可为空']: 'Không được để trống đội',
	['请输入对话内容关键字']: 'Vui lòng nhập từ khóa nội dung cuộc trò chuyện',
	['请输入客服本名、昵称或帐号']: 'Vui lòng nhập tên thật, biệt danh hoặc tài khoản khách hàng',
	['平台不可为空']: 'Nền tảng không được để trống',
	['线上']: 'Trực tuyến',
	['离线']: 'Ngoại tuyến',
	['日期不可为空']: 'Ngày không được để trống',
	['亲，跟您再次确认下，申请并进行此笔充值 {{chargeNumber}} 元的帐号是 {{chargeAccount}}，对吗？']: 'Xin xác nhận lại, bạn đang yêu cầu nạp {{chargeNumber}} đơn vị vào tài khoản {{chargeAccount}}, phải không?',
	['您的等待顺位为第 {{pendingOrder}} 位']: 'Vị trí chờ của bạn là thứ {{pendingOrder}}',
	['拒絕由 {{inviter}} 转接至 {{invitee}}']: 'Từ chối chuyển giao từ {{-inviter}} đến {{-invitee}}',
	['{{name}} 已于 {{time}} 关闭视窗']: '{{-name}} đã đóng cửa sổ vào {{-time}}',
	['{{name}} 已于 {{time}} 点选案件完成']: '{{-name}} đã hoàn thành lựa chọn vào {{-time}}',
	['{{name}} 已于 {{time}} 成功加入协作']: '{{-name}} đã tham gia hợp tác thành công vào {{-time}}',
	['{{name}} 已于 {{time}} 离开协作']: '{{-name}} đã rời khỏi hợp tác vào {{-time}}',
	['{{name}} 已于 {{time}} 中断连线']: '{{-name}} đã ngắt kết nối vào {{-time}}',
	['英文']: 'Tiếng Anh',
	['验证码设定']: 'Cài đặt mã xác minh',
	['启用验证码']: 'Kích hoạt mã xác minh',
	['设定验证码成功']: 'Cài đặt mã xác minh thành công',
	['启用验证码功能后，客户需完成验证才能进入客服系统等待区。']: 'Sau khi kích hoạt mã xác minh, khách hàng cần hoàn thành xác minh mới có thể vào khu vực chờ của hệ thống dịch vụ khách hàng.',
	['禁止连续发话']: 'Vui lòng không gửi tin nhắn liên tục',
	['启用禁止连续发话']: 'Kích hoạt cấm nói liên tục',
	['当会员在「限制秒数」内发话超过设定的次数，系统将会自动跳警告。']: 'Khi thành viên nói quá số lần cho phép trong "số giây giới hạn", hệ thống sẽ tự động cảnh báo.',
	['客户端限制于']: 'Giới hạn ở khách hàng',
	['发话次数达到']: 'Số lần phát biểu đã đạt',
	['次']: 'lần',
	['暂时无法发话']: 'Tạm thời không thể nói',
	['储存完成']: 'Lưu hoàn tất',
	['发送消息过于频繁 可稍后再试']: 'Gửi tin nhắn quá thường xuyên, bạn có thể thử lại sau',
	['IP黑名单管理']: 'Quản lý danh sách đen IP',
	['共 {{total}} 笔']: 'Tổng cộng {{total}} dữ liệu',
	['第 {{min}} - {{max}} 笔/共 {{total}} 笔']: 'Dữ liệu từ {{min}} đến {{max}} / Tổng cộng {{total}} dữ liệu',
	['顯示']: 'Hiển thị',
	['查询IP黑名单']: 'Truy vấn danh sách đen IP',
	['设定自动添加黑名单']: 'Thiết lập tự động thêm vào danh sách đen',
	['白名單管理']: 'Quản lý danh sách trắng',
	['解除时间']: 'Thời gian giải phóng',
	['永久封锁']: 'Khóa vĩnh viễn',
	['新增IP黑名单']: 'Thêm vào danh sách đen IP',
	['加入黑名单后，该IP将无法进入客服前台。']: 'Sau khi thêm vào danh sách đen, IP này sẽ không thể truy cập vào giao diện khách hàng',
	['请完成安全验证']: 'Vui lòng hoàn thành xác minh bảo mật',
	['向右滑动填充拼图']: 'Trượt sang phải để ghép hình',
	['启用功能']: 'Kích hoạt chức năng',
	['若IP于「限制时间」内登入超过设定的「登入次数」系统即自动加入黑名单。']: 'Nếu IP đăng nhập quá số lần cho phép trong "thời gian giới hạn", hệ thống sẽ tự động thêm vào danh sách đen',
	['限制时间']: 'Thời gian giới hạn',
	['时间单位不可为空']: 'Đơn vị thời gian không được để trống',
	['时间单位']: 'Đơn vị thời gian',
	['登入次数']: 'Số lần đăng nhập',
	['封锁时间']: 'Thời gian khóa',
	['锁的持续时间，时间到了会自动解除']: 'Thời gian khóa sẽ tự động được giải phóng khi hết hạn',
	['查询IP白名单']: 'Truy vấn danh sách trắng IP',
	['删除失败']: 'Xóa thất bại',
	['修改失败']: 'Sửa đổi thất bại',
	['拼图验证失败次数过多']: 'Xác minh ghép hình thất bại quá nhiều lần',
	['{{name}} 已于 {{time}} 拒絕加入协作']: '{{-name}} đã từ chối tham gia hợp tác vào {{-time}}',
	['储存过滤模組成功']: 'Lưu bộ lọc mô-đun thành công',
	['删除过滤模組成功']: 'Xóa bộ lọc mô-đun thành công',
	['解除谷歌验证成功']: 'Giải phóng xác minh Google thành công',
	['确定禁用平台?']: 'Bạn có chắc muốn vô hiệu hóa nền tảng không?',
	['确定启用平台?']: 'Bạn có chắc muốn kích hoạt nền tảng không?',
	['IP管理(客户端)']: 'Quản lý IP (khách hàng)',
	['上传']: 'Tải lên',
	['此栏位的时间会使用于报表的团队筛选']: 'Thời gian của mục này sẽ được sử dụng để lọc theo đội trong báo cáo',
	['选择团队：筛选出该团队所有客服人员在团队统计时间中的数据']: 'Chọn đội: Lọc dữ liệu của tất cả nhân viên khách hàng trong đội theo thời gian thống kê',
	['备注最多{{inputLimit}}个字']: 'Ghi chú không quá {{inputLimit}} từ',
	['{{inviter}} 已于 {{time}} 将对话从 {{from}} 转接给 {{invitee}}']: '{{-inviter}} đã chuyển cuộc trò chuyện từ {{-from}} đến {{-invitee}} vào {{-time}}',
	['小时']: 'Giờ',
	['日']: 'Ngày',
	['会员IP：{{ip}} 已加入前台黑名单']: 'IP thành viên: {{ip}} đã được thêm vào danh sách đen giao diện',
	['新增失败']: 'Thêm thất bại',
	['会员IP被加入黑名单']: 'IP thành viên đã được thêm vào danh sách đen',
	['登入/接待时间']: 'Thời gian đăng nhập/tiếp nhận',
	['timePeriodTooltipMessage']: '<divAnchor><pAnchor>Bộ lọc thời gian chỉ có thể lọc theo giờ mà không thể lọc theo ngày. Nếu thời gian thống kê của nhóm được đặt qua ngày, ngày sẽ không thay đổi theo.</pAnchor><pAnchor>Ví dụ:<brAnchor/>Thời gian thống kê của nhóm được đặt từ 23:00 đến 07:30<brAnchor/>Truy vấn từ 00:00 đến 23:59 vào ngày 1/9<brAnchor/>Lọc thời gian từ 02:00 đến 03:00<brAnchor/>Sau khi lọc, dữ liệu cho ngày 1/9 sẽ từ 02:00 đến 03:00<brAnchor/>Kết quả dữ liệu này không trùng với thời gian thống kê của nhóm vào ngày 1/9 (từ 23:00 ngày 1/9 đến 07:30 ngày 2/9), vì vậy dữ liệu sẽ bằng 0<brAnchor/></pAnchor></divAnchor>',
	['平均接待时间']: 'Thời gian tiếp nhận trung bình',
	['平均登入时间']: 'Thời gian đăng nhập trung bình',
	['接待时间报表']: 'Báo cáo thời gian tiếp nhận',
	['登入时间报表']: 'Báo cáo thời gian đăng nhập',
	['未登入']: 'Chưa đăng nhập',
	['设定报表']: 'Thiết lập báo cáo',
	['设定对话是否记入报表中']: 'Thiết lập liệu cuộc trò chuyện có được ghi vào báo cáo không',
	['平均通话时长报表']: 'Báo cáo thời gian cuộc gọi trung bình',
	['平均通话数报表']: 'Báo cáo số lượng cuộc gọi trung bình',
	['平均等待时间报表']: 'Báo cáo thời gian chờ trung bình',
	['客户满意度报表']: 'Báo cáo độ hài lòng của khách hàng',
	['平均回覆时间报表']: 'Báo cáo thời gian phản hồi trung bình',
	['调整原因']: 'Lý do điều chỉnh',
	['请输入调整原因']: 'Vui lòng nhập lý do điều chỉnh',
	['调整原因不可为空']: 'Lý do điều chỉnh không được để trống',
	['日期时间']: 'Ngày giờ',
	['操作人']: 'Người thao tác',
	['原因']: 'Lý do',
	['更多']: 'Nhiều hơn',
	['收回']: 'Thu hồi',
	['设定报表成功']: 'Thiết lập báo cáo thành công',
	['平均回覆时间']: 'Thời gian phản hồi trung bình',
	['客服平均回覆时间']: 'Thời gian phản hồi trung bình của dịch vụ khách hàng',
	['客户回头率']: 'Tỷ lệ khách hàng quay lại',
	['客户ID']: 'ID khách hàng',
	['客服帐号']: 'Tài khoản dịch vụ khách hàng',
	['小时回头率']: 'Tỷ lệ quay lại hàng giờ',
	['日回头率']: 'Tỷ lệ quay lại hàng ngày',
	['遗漏时间']: 'Thời gian bỏ lỡ',
	['请选择遗漏时间']: 'Vui lòng chọn thời gian bỏ lỡ',
	['平均遗漏时间']: 'Thời gian bỏ lỡ trung bình',
	['1分钟']: '1 phút',
	['2分钟']: '2 phút',
	['3分钟']: '3 phút',
	['4分钟']: '4 phút',
	['5分钟']: '5 phút',
	['离开时间']: 'Thời gian rời đi',
	['客户回头率报表']: 'Báo cáo tỷ lệ khách hàng quay lại',
	['平台报表']: 'Báo cáo nền tảng',
	['对话总量']: 'Tổng số cuộc trò chuyện',
	['接待总量']: 'Tổng số lượt tiếp nhận',
	['遗漏总量']: 'Tổng số lượt bỏ lỡ',
	['智能客服总量']: 'Tổng số dịch vụ khách hàng thông minh',
	['智能转客服总量']: 'Tổng số chuyển từ thông minh sang dịch vụ khách hàng',
	['最后更新时间']: 'Thời gian cập nhật cuối cùng',
	['客服人数']: 'Số lượng nhân viên dịch vụ khách hàng',
	['在线客服总数']: 'Tổng số nhân viên dịch vụ khách hàng trực tuyến',
	['等待服务']: 'Đang chờ dịch vụ',
	['正在服务']: 'Đang phục vụ',
	['智能未转客服总量']: 'Tổng số dịch vụ khách hàng thông minh chưa chuyển đổi',
	['使用平台']: 'Nền tảng sử dụng',
	['泰文名称']: 'Tên bằng tiếng Thái',
	['请输入泰文名称']: 'Vui lòng nhập tên bằng tiếng Thái',
	['英文名称']: 'Tên bằng tiếng Anh',
	['请输入英文名称']: 'Vui lòng nhập tên bằng tiếng Anh',
	['中文名称']: 'Tên bằng tiếng Trung',
	['请输入中文名称']: 'Vui lòng nhập tên bằng tiếng Trung',
	['若无需翻译请填写中文']: 'Nếu không cần dịch, vui lòng điền bằng tiếng Trung',
	['帐号所有报表数据将连同帐号一同删除，请问确认要删除吗？']: 'Tất cả dữ liệu báo cáo của tài khoản sẽ bị xóa cùng với tài khoản, bạn có chắc muốn xóa không?',
	['停用']: 'Vô hiệu hóa',
	['停用帐号']: 'Vô hiệu hóa tài khoản',
	['通话总数']: 'Tổng số cuộc gọi',
	['等待中人数：{{pendingConversationCount}} 人']: 'Số người đang chờ: {{pendingConversationCount}} người',
	['报表正在汇出中，请前往页面「报表下载」查看进度并进行下载。']: 'Báo cáo đang được xuất, vui lòng truy cập trang "Tải xuống báo cáo" để xem tiến trình và thực hiện tải xuống.',
	['汇出Load Data']: 'Xuất dữ liệu',
	['报表下载']: 'Tải xuống báo cáo',
	['全平台']: 'Toàn nền tảng',
	['报表类型']: 'Loại báo cáo',
	['数据范围']: 'Phạm vi dữ liệu',
	['汇出时间']: 'Thời gian xuất',
	['完成时间']: 'Thời gian hoàn thành',
	['申请者']: 'Người yêu cầu',
	['下载']: 'Tải xuống',
	['重新汇出']: 'Xuất lại',
	['处理中']: 'Đang xử lý',
	['已完成']: 'Đã hoàn thành',
	['失败']: 'Thất bại',
	['下载成功']: 'Tải xuống thành công',
	['历史对话纪录']: 'Lịch sử cuộc trò chuyện',
	['连线中断，请点击确定尝试恢复连线，若无法恢复将结束对话。']: 'Kết nối bị gián đoạn, vui lòng nhấn Xác nhận để thử kết nối lại, nếu không thể khôi phục sẽ kết thúc cuộc trò chuyện.',
	['引用功能管理']: 'Quản lý chức năng trích dẫn',
	['引用对话']: 'Trích dẫn cuộc trò chuyện',
	['设定引用对话成功']: 'Thiết lập trích dẫn cuộc trò chuyện thành công',
	['客户管理']: 'Quản lý khách hàng',
	['重要客户帐号']: 'Tài khoản khách hàng quan trọng',
	['请输入重要客户帐号、备注等关键字']: 'Vui lòng nhập tài khoản khách hàng quan trọng, ghi chú và các từ khóa khác',
	['新增重要客户']: 'Thêm khách hàng quan trọng',
	['重要客户帐号不能为空']: 'Tài khoản khách hàng quan trọng không được để trống',
	['输入多个帐号请用, 区隔']: 'Vui lòng nhập nhiều tài khoản, sử dụng dấu phẩy để phân cách',
	['修改重要客户']: 'Chỉnh sửa khách hàng quan trọng',
	['重要帐号']: 'Tài khoản quan trọng',
	['会员类型']: 'Loại thành viên',
	['引用']: 'Trích dẫn',
	['收回(訊息)']: 'Thu hồi',
	['收回功能管理']: 'Quản lý chức năng thu hồi',
	['收回提示文字不能为空']: 'Văn bản nhắc nhở thu hồi không được để trống',
	['收回对话']: 'Thu hồi cuộc trò chuyện',
	['收回提示文字（中文）']: 'Văn bản nhắc nhở thu hồi (tiếng Trung)',
	['收回提示文字（英文）']: 'Văn bản nhắc nhở thu hồi (tiếng Anh)',
	['收回提示文字（泰文）']: 'Văn bản nhắc nhở thu hồi (tiếng Thái)',
	['视频']: 'Video',
	['确定要收回讯息吗？']: 'Bạn có chắc muốn thu hồi tin nhắn không?',
	['设定收回功能成功']: 'Thiết lập chức năng thu hồi thành công',
	['遗漏数据']: 'Dữ liệu bị bỏ lỡ',
	['全选']: 'Chọn tất cả',
	['请选择使用平台']: 'Vui lòng chọn nền tảng sử dụng',
	['日期计算方式']: 'Phương pháp tính ngày',
	['以会员进入正在服务区的时间计算']: 'Tính theo thời gian thành viên vào khu vực đang phục vụ',
	['以会员进入等待服务区的时间计算，若是点击智能客服未进入等待服务区则以点入智能客服的时间计算']: 'Tính theo thời gian thành viên vào khu vực chờ, nếu nhấp vào dịch vụ khách hàng thông minh mà không vào khu vực chờ thì tính theo thời gian nhấp vào dịch vụ khách hàng thông minh',
	['以会员进入等待服务区的时间计算']: 'Tính theo thời gian thành viên vào khu vực chờ',
	['以客服接通对话的时间进行计算']: 'Tính theo thời gian dịch vụ khách hàng kết nối cuộc trò chuyện',
	['以会员进入等待服务区的时间进行计算']: 'Tính theo thời gian thành viên vào khu vực chờ',
	['以会员点击智能客服的时间计算']: 'Tính theo thời gian thành viên nhấp vào dịch vụ khách hàng thông minh',
	['相同类型才会计算回头']: 'Chỉ tính khi cùng loại',
	['登入联系离开后再次登入联系']: 'Liên hệ đăng nhập, rời đi sau đó đăng nhập lại',
	['一通对话只会触发一次回头次数']: 'Một cuộc trò chuyện chỉ kích hoạt một lần đếm số lần quay lại',
	['同一会员时间内连续联系3次，计算前两通对话的客服各1次回头']: 'Trong cùng một ngày, liên hệ liên tục 3 lần, tính 1 lần quay lại cho mỗi hai cuộc trò chuyện đầu của dịch vụ khách hàng',
	['每日同一会员于对话结束后{{hour}}小时内又重复联系的有效对话比例']: 'Tỷ lệ cuộc trò chuyện hiệu quả lặp lại trong {{-hour}} giờ sau khi cuộc trò chuyện kết thúc hàng ngày',
	['未登入联系离开后再次未登入联系']: 'Liên hệ chưa đăng nhập, rời đi sau đó lại liên hệ chưa đăng nhập',
	['请输入重要客户帐号']: 'Vui lòng nhập tài khoản khách hàng quan trọng',
	['开始日期']: 'Ngày bắt đầu',
	['结束日期']: 'Ngày kết thúc',
	['标签名称/数量']: 'Tên nhãn / số lượng',
	['暂无数据']: 'Không có dữ liệu',
	['AI客服设定']: 'Cài đặt dịch vụ khách hàng AI',
	['AI共同设定']: 'Cài đặt chung AI',
	['平台AI设定']: 'Cài đặt nền tảng AI',
	['平台 AI SKILL 设定']: 'Cài đặt nền tảng AI SKILL',
	['指令输入说明']: 'Hướng dẫn nhập lệnh',
	['输入文字档']: 'Nhập tài liệu văn bản',
	['不需要区分功能']: 'Không cần phân biệt chức năng',
	['套用平台']: 'Áp dụng nền tảng',
	['请输入指令']: 'Vui lòng nhập lệnh',
	['AI与会员对话超过 <<inputNumber>> 轮后需要通知客服人员']: 'Sau khi AI và thành viên trò chuyện vượt quá <<inputNumber>> vòng, cần thông báo cho nhân viên hỗ trợ',
	['指令']: 'Lệnh',
	['AI开关']: 'Bật tắt AI',
	['AI客服名称']: 'Tên dịch vụ khách hàng AI',
	['AI客服名称不能为空']: 'Tên dịch vụ khách hàng AI không được để trống',
	['请输入AI客服名称']: 'Vui lòng nhập tên dịch vụ khách hàng AI',
	['是否要关闭AI客服？关闭后将无法再度开启AI客服']: 'Có muốn tắt dịch vụ khách hàng AI không? Sau khi tắt sẽ không thể mở lại dịch vụ khách hàng AI',
	['侦测到对话有异常状态，请尽快处理']: 'Phát hiện trạng thái hội thoại bất thường, vui lòng xử lý ngay',
	['需要转接人工客服，请尽快处理']: 'Cần chuyển tiếp sang nhân viên hỗ trợ, vui lòng xử lý ngay',
	['总平均通话时长']: 'Thời gian cuộc gọi trung bình tổng',
	['AI平均通话时长']: 'Thời gian cuộc gọi trung bình của AI',
	['人工平均通话时长']: 'Thời gian cuộc gọi trung bình của nhân viên',
	['每日总平均']: 'Tổng thời gian trung bình mỗi ngày',
	['AI日平均']: 'Thời gian trung bình hàng ngày của AI',
	['人工日平均']: 'Thời gian trung bình hàng ngày của nhân viên',
	['通话总量']: 'Tổng số cuộc gọi',
	['AI通话总量']: 'Tổng số cuộc gọi của AI',
	['共同']: 'Chung',
	['总计']: 'Tổng kết',
	['总计请勿超过{{limit}}字']: 'Tổng kết không quá {{limit}} ký tự',
	['总平均回覆时间']: 'Thời gian phản hồi trung bình tổng',
	['AI平均回覆时间']: 'Thời gian phản hồi trung bình của AI',
	['人工平均回覆时间']: 'Thời gian phản hồi trung bình của nhân viên',
	['AI日总量']: 'Tổng số ngày của AI',
	['人工日总量']: 'Tổng số ngày của nhân viên',
	['指令不能为空']: 'Lệnh không được để trống',
	['{{name}} 已于 {{time}} 开启AI']: '{{-name}} đã mở AI vào {{-time}}',
	['{{name}} 已于 {{time}} 关闭AI']: '{{-name}} đã đóng AI vào {{-time}}',
	['人机合作日总量']: 'Tổng số ngày hợp tác giữa người và máy',
	['人工通话总量']: 'Tổng số cuộc gọi của nhân viên',
	['人机合作通话总量']: 'Tổng số cuộc gọi hợp tác giữa người và máy',
	['以对话建立时间计算']: 'Tính theo thời gian tạo cuộc trò chuyện',
	['侦测到对话有异常状态 - 对话次数超过限制']: 'Phát hiện trạng thái hội thoại bất thường - Số lần hội thoại vượt quá giới hạn',
	['侦测到对话有异常状态 - 系统发生错误']: 'Phát hiện trạng thái hội thoại bất thường - Hệ thống xảy ra lỗi',
	['人机合作-人工日平均']: 'Trung bình hàng ngày hợp tác giữa nhân viên và AI',
	['人机合作-AI日平均']: 'Trung bình hàng ngày hợp tác giữa AI và nhân viên',
	['人机合作-人工平均通话时长']: 'Thời gian trung bình cuộc gọi hợp tác giữa nhân viên và AI',
	['人机合作-AI平均通话时长']: 'Thời gian trung bình cuộc gọi hợp tác giữa AI và nhân viên',
	['侦测到对话有异常状态 - 等待AI API超过两分钟']: 'Phát hiện trạng thái hội thoại bất thường - Chờ AI API quá 2 phút',
	['侦测到对话有异常状态 - AI 发生错误']: 'Phát hiện trạng thái hội thoại bất thường - AI xảy ra lỗi',
	['侦测到对话有异常状态 - AI 没有回复']: 'Phát hiện trạng thái hội thoại bất thường - AI không phản hồi',
	['数据']: 'Dữ liệu',
	['指令不能超过{{limit}}字']: 'Lệnh không được vượt quá {{limit}} ký tự',
	['数据不能为空']: 'Dữ liệu không được để trống',
	['数据不能超过100万字']: 'Dữ liệu không được vượt quá 1 triệu từ',
	['需{{limit}}字以内']: 'Cần trong vòng {{limit}} ký tự',
	['数据输入说明']: 'Hướng dẫn nhập dữ liệu',
	['需100万字以内']: 'Yêu cầu dưới 1 triệu từ',
	['至少要有一组 ~~~~~ 与 =====']: 'Phải có ít nhất một cặp ~~~~~ và =====',
	['分隔符号 ~~~~~ 与 ===== 需成对出现']: 'Dấu phân cách ~~~~~ và ===== phải xuất hiện theo cặp',
	['需以 ===== 结尾']: 'Phải kết thúc bằng =====',
	['标题底下使用5个波浪号并换行，波浪号的开头与结尾不能有其他文字或空格']: 'Đặt 5 dấu ngã ở dòng bên dưới tiêu đề, không có ký tự hoặc khoảng trắng nào ở trước và sau',
	['内容底下使用5个等号并换行，等号的开头与结尾不能有其他文字或空格']: 'Đặt 5 dấu bằng ở dòng bên dưới nội dung, không có ký tự hoặc khoảng trắng nào ở trước và sau',
	['范例']: 'Ví dụ',
	['标题A（可多行）']: 'Tiêu đề A (có thể nhiều dòng)',
	['内容A（可多行，可含任何文字）']: 'Nội dung A (nhiều dòng, có thể chứa bất kỳ văn bản nào)',
	['标题B（可多行）']: 'Tiêu đề B (có thể nhiều dòng)',
	['内容B（可多行，可含任何文字）']: 'Nội dung B (nhiều dòng, có thể chứa bất kỳ văn bản nào)',
	['模型顺序（上方模型优先使用，失效时自动往下切换）']: 'Thứ tự mô hình (mô hình ở trên được ưu tiên sử dụng, khi lỗi sẽ tự động chuyển xuống mô hình tiếp theo)',
	['主要']: 'Chính',
	['备援{{index}}']: 'Dự phòng {{index}}',
	['新增备援模型']: 'Thêm mô hình dự phòng',
	['请输入数据']: 'Vui lòng nhập dữ liệu',
	['正在转接中...']: 'Đang chuyển tiếp...',
	['（中文）']: '(Tiếng Trung)',
	['（英文）']: '(Tiếng Anh)',
	['（泰文）']: '(Tiếng Thái)',
	['（越南文）']: '(Tiếng Việt)',
	['越南文名称']: 'Tên tiếng Việt',
	['请输入越南文名称']: 'Vui lòng nhập tên tiếng Việt',
	['模式']: 'Chế độ',
	['越南语']: 'Tiếng Việt',
	['IP白名单设定']: 'Cài đặt danh sách trắng IP',
	['建立时间']: 'Thời gian tạo',
	['批次删除']: 'Xóa hàng loạt',
	['请确认是否删除 IP 白名单？']: 'Vui lòng xác nhận liệu bạn có muốn xóa danh sách trắng IP không?',
	['开启快捷选单']: 'Mở menu nhanh',
	['收合快捷选单']: 'Thu gọn menu nhanh',
	['是否有收回人员讯息']: 'Có thu hồi thông điệp nhân viên không',
	['是否有收回AI讯息']: 'Có thu hồi thông điệp AI không',
	['消息已被客服撤回']: 'Thông điệp đã được nhân viên dịch vụ khách hàng rút lại',
	['用户快捷选单管理']: 'Quản lý menu nhanh của người dùng',
	['电脑预览']: 'Xem trước trên máy tính',
	['手机预览']: 'Xem trước trên điện thoại',
	['档案格式：PNG、JPG、JPEG']: 'Định dạng tệp: PNG, JPG, JPEG',
	['请选择上传档案']: 'Vui lòng chọn tệp để tải lên',
	['新增快捷成功']: 'Thêm nhanh thành công',
	['修改快捷成功']: 'Chỉnh sửa nhanh thành công',
	['设定快捷选单成功']: 'Thiết lập menu nhanh thành công',
	['删除快捷成功']: 'Xóa nhanh thành công',
	['确定删除此快捷？']: 'Bạn có chắc muốn xóa nhanh này không?',
	['新增内容']: 'Thêm Nội Dung',
	['选项內容']: 'Nội dung tùy chọn',
	['{{itemLabel}}內容不能为空']: 'Nội dung {{-itemLabel}} không được để trống',
	['请输入{{itemLabel}}标题']: 'Vui lòng nhập tiêu đề {{-itemLabel}}',
	['请输入{{itemLabel}}选项']: 'Vui lòng nhập tùy chọn {{-itemLabel}}',
	['{{text}}不可为空']: '{{-text}} không được để trống',
	['显示更多']: 'Hiển thị thêm',
	['公告标签']: 'Thông báo nhãn',
	['请选择公告标签']: 'Vui lòng chọn nhãn thông báo',
	['{{text}}标题']: '{{-text}}Tiêu đề',
	['{{text}}內文']: '{{-text}}Nội dung',
	['{{text}}最多{{inputLimit}}个字']: '{{-text}}Tối đa {{inputLimit}} ký tự',
	['公告内文档案大小总计不得大于10MB']: 'Tổng dung lượng tệp tin nội dung thông báo không được lớn hơn 10MB',
	['用户尚未离开，确认要完成对话？']: 'Người dùng vẫn chưa rời đi. Xác nhận hoàn tất cuộc trò chuyện?',
	['{{name}} 已于 {{time}} 离开对话']: '{{-name}} đã rời khỏi cuộc trò chuyện vào {{-time}}.',
	['客服人员']: 'Dịch vụ khách hàng',
	['*新增多个IP请使用逗号「 , 」隔开']: '*Để thêm nhiều IP, vui lòng sử dụng dấu phẩy (,) để phân cách chúng.',
	['是否新增IP白名单？']: 'Bạn có muốn thêm danh sách IP trắng không?',
	['IP已存在']: 'IP đã tồn tại',
	['监控区管理']: 'Quản lý khu vực giám sát',
	['监控区开关']: 'Chuyển đổi khu vực giám sát',
	['设定监控区开关成功']: 'Chuyển đổi khu vực giám sát đã được thiết lập thành công.',
	['启用功能后，等待服务区会增加一个[监控区]页签，显示全平台被AI拦截的对话与未读时间最长的5通对话，点击可快速跳转至相应对话。']: 'Sau khi kích hoạt tính năng này, một tab [Khu vực giám sát] sẽ được thêm vào khu vực chờ dịch vụ, hiển thị các cuộc trò chuyện bị AI chặn trên toàn nền tảng cùng 5 cuộc trò chuyện chưa đọc lâu nhất. Nhấp vào để nhanh chóng chuyển đến cuộc trò chuyện tương ứng.',
	['{{name}} 新增了标签 {{tag}}']: '{{-name}} đã thêm nhãn {{-tag}}',
	['{{name}} 移除了标签 {{tag}}']: '{{-name}} đã gỡ nhãn {{-tag}}',
	['状态切换为暂离']: 'Chuyển trạng thái sang Tạm vắng',
	['状态切换为工作中']: 'Chuyển trạng thái sang Đang làm việc',
	['监控区']: 'Khu vực giám sát',
	['自动接线管理']: 'Quản lý kết nối tự động',
	['客服全平台接待数量达到上限后，系统不会自动接入等待服务区的对话，客服人员手动接入数量不限制。']: 'Sau khi số lượng cuộc trò chuyện được tiếp nhận trên toàn nền tảng đạt giới hạn, hệ thống sẽ không tự động chuyển các cuộc trò chuyện vào khu vực chờ, nhưng nhân viên có thể tiếp nhận thủ công không giới hạn.',
	['自动接线数量上限']: 'Giới hạn số lượng kết nối tự động',
	['设定自动接线成功']: 'Thiết lập kết nối tự động thành công',
	['{{name}} 进线']: '{{-name}} vào đường dây',
	['工作/暂离时间']: 'Thời gian làm việc/Tạm vắng',
	['工作时长报表']: 'Báo cáo thời gian làm việc',
	['暂离时长报表']: 'Báo cáo thời gian tạm vắng',
	['平均工作时长']: 'Thời gian làm việc trung bình',
	['平均暂离时长']: 'Thời gian tạm vắng trung bình',
	['关键字提醒']: 'Nhắc nhở từ khóa',
	['客户发话']: 'Khách hàng phát ngôn',
	['AI发话']: 'AI phát ngôn',
	['发话来源']: 'Nguồn phát ngôn',
	['请输入发话来源、关键字']: 'Vui lòng nhập nguồn phát ngôn, từ khóa',
	['新增关键字']: 'Thêm từ khóa',
	['修改关键字']: 'Chỉnh sửa từ khóa',
	['新增关键字成功']: 'Thêm từ khóa thành công',
	['修改关键字成功']: 'Chỉnh sửa từ khóa thành công',
	['删除关键字成功']: 'Xóa từ khóa thành công',
	['是否删除此关键字？']: 'Bạn có muốn xóa từ khóa này không?',
	['请用「；」来分隔不同关键字，关键字不得超过100个字']: 'Vui lòng dùng dấu 「；」 để tách các từ khóa khác nhau, không quá 100 từ khóa.',
	['客户触发关键字 [{{word}}] 请客服人员注意']: 'Khách hàng đã kích hoạt từ khóa [{{-word}}], vui lòng chú ý.',
	['AI触发关键字 [{{word}}] 请客服人员注意']: 'AI đã kích hoạt từ khóa [{{-word}}], vui lòng chú ý.',
	['请输入通知时间']: 'Vui lòng nhập thời gian thông báo',
	['自动接线开关']: 'Công tắc kết nối tự động',
	['自动接线数量上限不可为空']: 'Giới hạn số lượng kết nối tự động không được để trống',
	['请输入数量上限']: 'Vui lòng nhập giới hạn số lượng',
	['离开状态侦测开关']: 'Công tắc phát hiện trạng thái vắng mặt',
	['开启后当客服人员为平台最后一个工作状态或仍有接待中且无协作给他人对话时，无法切换为离开状态。']: 'Khi bật, nhân viên chăm sóc khách hàng không thể chuyển sang trạng thái vắng mặt nếu họ là người cuối cùng hoạt động trên nền tảng hoặc nếu còn cuộc trò chuyện chưa được chuyển giao cho người khác',
	['离开时间通知开关']: 'Công tắc thông báo thời gian vắng mặt',
	['通知时间不可重复']: 'Thời gian thông báo không được trùng lặp',
	['侦测权限CS帐号离开时间，离开时间达设定时间时通知权限manager以上的帐号，以及触发离开时间的CS帐号本人。']: 'Phát hiện quyền hạn thời gian vắng mặt của tài khoản CS. Thông báo cho tài khoản có quyền hạn từ cấp quản lý trở lên và tài khoản CS kích hoạt trạng thái vắng mặt khi thời gian vắng mặt đạt đến mức thiết lập',
	['最后暂离时间报表']: 'Báo cáo thời gian vắng mặt cuối cùng',
	['平均最后暂离时间']: 'Thời gian khởi hành tạm thời trung bình cuối cùng',
	['{{name}} 离开时间已达 [{{minute}}] 分钟 !']: '{{-name}} đã vắng mặt trong [{{minute}}] phút!',
	['历史对话记录下载']: 'Tải xuống lịch sử cuộc trò chuyện',
	['使用模式']: 'Chế độ sử dụng',
	['标准模式']: 'Chế độ tiêu chuẩn',
	['ID模式']: 'Chế độ ID',
	['即进模式']: 'Chế độ truy cập nhanh',
	['复制即进网址']: 'Sao chép URL truy cập nhanh',
	['生成新网址']: 'Tạo URL mới',
	['需提供客户Profile资料的标准模式，此模式为系统预设模式。']: 'Chế độ tiêu chuẩn yêu cầu thông tin hồ sơ khách hàng và là chế độ mặc định của hệ thống',
	['输入ID 进入客服，可不提供客戶Profile资料。']: 'Nhập ID để truy cập chăm sóc khách hàng mà không cần cung cấp thông tin hồ sơ khách hàng',
	['透过即进网址可直接进入客服系统，无需提供资料，系统自动给予随机访客名称。']: 'Sử dụng URL truy cập nhanh để truy cập trực tiếp vào hệ thống chăm sóc khách hàng mà không cần cung cấp bất kỳ thông tin nào. Hệ thống sẽ tự động gán tên ngẫu nhiên cho khách truy cập',
	['请再次确认是否從 [<<prevTypeText>>] 切至 [<<nextTypeText>>]']: 'Vui lòng xác nhận chuyển từ [<<prevTypeText>>] sang [<<nextTypeText>>]',
	['以下是即进网址']: 'Dưới đây là URL truy cập nhanh',
	['复制网址']: 'Sao chép URL',
	['使用模式切换成功']: 'Chuyển đổi chế độ sử dụng thành công',
	['请再次确认是否更换网址 ，一经更换<<redText>>']: 'Vui lòng xác nhận có thay đổi URL không. Sau khi thay đổi, <<redText>>',
	['当前即进网址']: 'URL truy cập nhanh hiện tại',
	['新即进网址']: 'URL truy cập nhanh mới',
	['复制即进网址成功']: 'Sao chép URL truy cập nhanh thành công',
	['报表统计']: 'Thống kê báo cáo',
	['操作時間']: 'Thời gian thao tác',
	['统计类型']: 'Loại thống kê',
	['请选择统计类型']: 'Vui lòng chọn loại thống kê',
	['查询参数']: 'Tham số truy vấn',
	['申请时间']: 'Thời gian yêu cầu',
	['产出时间']: 'Thời gian xuất kết quả',
	['申请帐号']: 'Tài khoản yêu cầu',
	['详细资料']: 'Thông tin chi tiết',
	['重新执行统计']: 'Thực hiện lại thống kê',
	['执行统计']: 'Thực hiện thống kê',
	['登入时间范围']: 'Thời gian đăng nhập',
	['选择团队：筛选出该团队所有客服人员']: 'Chọn đội ngũ: Lọc tất cả nhân viên chăm sóc khách hàng của đội ngũ này.',
	['API接收日志']: 'Nhật ký tiếp nhận API',
	['新增来源']: 'Thêm nguồn',
	['CS']: 'CS',
	['包网']: 'bao mạng',
	['包网API']: 'Gói API',
	['第 {{min}} - {{max}} 笔']: 'Bút thứ {{min}} - {{max}}',
	['选择的日期区间需小于等于{{limit}}天']: 'Khoảng thời gian đã chọn không được lớn hơn {{limit}} ngày.',
	['请选择日期时间查询条件']: 'Vui lòng chọn điều kiện ngày giờ để tra cứu',
	['类型']: 'Loại',
	['公司']: 'công ty',
	['请输入公司']: 'Hãy nhập công ty',
	['会员帐号']: 'Tài khoản thành viên',
	['请输入会员帐号']: 'Vui lòng nhập tài khoản thành viên',
	['是否查看详细资料？']: 'Bạn có muốn xem thông tin chi tiết không?',
	['传送资料']: 'Chuyển dữ liệu',
	['CS回覆资料']: 'Dữ liệu phản hồi CS',
	['内容']: 'Nội dung',
	['请选择进入的公司']: 'Vui lòng chọn công ty để vào',
	['指令数据更新纪录']: 'Ghi chép cập nhật dữ liệu lệnh',
	['1.排序机制：所有公司的指令将统一排序处理，确保系统高效运作。']: 'Cơ chế sắp xếp: Tất cả chỉ thị của các công ty sẽ được xử lý theo thứ tự thống nhất, đảm bảo hệ thống hoạt động hiệu quả.',
	['2.数据隔离：用户仅能查看自己公司的更新记录，无法查看其他公司的记录。']: '2. Tách biệt dữ liệu: Người dùng chỉ có thể xem hồ sơ cập nhật của công ty mình, không thể xem hồ sơ của công ty khác.',
	['微调训练']: 'Tinh chỉnh đào tạo',
	['执行微调']: 'Thực hiện tinh chỉnh',
	['操作帐号']: 'Tài khoản操作',
	['是否修改AI API?']: 'Có sửa đổi API AI không?',
	['保存设置']: 'Lưu cài đặt',
	['修改AI API成功']: 'Sửa đổi API AI thành công',
	['请输入{{text}}']: 'Vui lòng nhập {{text}}',
	['{{text}}不能超过{{limit}}字元']: '{{text}} không được vượt quá {{limit}} ký tự',
	['AI API']: 'API AI',
	['微调训练记录']: 'Ghi chép đào tạo tinh chỉnh',
	['模型名称']: 'tên mô hình',
	['新增文本']: 'Thêm văn bản',
	['修改文本']: 'Chỉnh sửa văn bản',
	['请输入名称']: 'Nhập tên',
	['取消修改微调文本']: 'Hủy bỏ chỉnh sửa văn bản tinh chỉnh',
	['角色不可为空']: 'Vai trò không được để trống',
	['请选择角色']: 'Xin vui lòng chọn nhân vật',
	['内容不可为空']: 'Nội dung không được để trống',
	['请输入内容']: 'Vui lòng nhập nội dung',
	['系统']: 'Hệ thống',
	['会员']: 'thành viên',
	['AI']: 'AI',
	['请确认是否取消？']: 'Xin xác nhận có muốn hủy không?',
	['新增微调文本成功']: 'Thêm văn bản tinh chỉnh thành công',
	['修改微调文本成功']: 'Chỉnh sửa văn bản thành công',
	['自定模型名称']: 'Đặt tên mô hình tự định nghĩa',
	['微调确认讯息']: 'Thông điệp xác nhận tinh chỉnh',
	['请确认是否执行微调训练？']: 'Bạn có xác nhận thực hiện đào tạo tinh chỉnh không?',
	['删除微调文本']: 'Xóa văn bản tinh chỉnh',
	['请确认是否刪除？']: 'Xin vui lòng xác nhận có muốn xóa không?',
	['刪除微调文本成功']: 'Xóa văn bản tinh chỉnh thành công',
	['请输入模型名称']: 'Vui lòng nhập tên mô hình',
	['执行微调成功']: 'Thực hiện tinh chỉnh thành công',
	['取消修改文本成功']: 'Hủy chỉnh sửa văn bản thành công',
	['取消新增文本成功']: 'Hủy thêm văn bản thành công',
	['您已成功登出客服系统。']: 'Bạn đã đăng xuất thành công khỏi hệ thống dịch vụ khách hàng.',
	['如需重新登录，请返回包网！']: 'Nếu cần đăng nhập lại, vui lòng quay lại Bao Wang!',
	['您已成功登出客服系统管理端。']: 'Bạn đã đăng xuất thành công khỏi hệ thống quản lý dịch vụ khách hàng.',
	['当「平均等待时间」显示为 0 秒时，可能的原因如下：']: 'Khi "thời gian chờ trung bình" hiển thị là 0 giây, các nguyên nhân có thể như sau:',
	['1.当日所有对话的等待时间均为 0 秒（例如因自动接线或即时应答，无需等待）。']: 'Thời gian chờ cho tất cả các cuộc trò chuyện trong ngày hôm đó đều là 0 giây (ví dụ, do tự động trả lời hoặc trả lời ngay lập tức, không cần chờ đợi).',
	['2.根据公式 「每日总等待时间 ÷ 每日对话数量」，计算结果经四舍五入后为 0 秒。']: '2. Theo công thức "Thời gian chờ tổng cộng hàng ngày ÷ Số lượng cuộc hội thoại hàng ngày", kết quả sau khi làm tròn là 0 giây.',
	['系统显示为 「未登入」 时，表示该帐号在其设定的团队时间内未产生任何对话数据。']: 'Hệ thống hiển thị là "Chưa đăng nhập" có nghĩa là tài khoản đó trong khoảng thời gian đã thiết lập không có bất kỳ dữ liệu trò chuyện nào.',
	['加入微调']: 'Tham gia tinh chỉnh',
	['启用API Key']: 'Kích hoạt API Key',
	['微调汇入对话记录']: 'Điều chỉnh nhẹ cuộc hội thoại',
	['对话数量']: 'Số lượng cuộc đối thoại',
	['文本最后角色需为AI或客服人员']: 'Nhân vật cuối cùng của văn bản phải là AI hoặc nhân viên chăm sóc khách hàng.',
	['汇入微调文本']: 'Nhập văn bản tinh chỉnh',
	['檔案格式：CSV，且档案大小不得大于']: 'Định dạng tệp: CSV và kích thước tệp không được lớn hơn',
	['文本最后角色需为AI或客服人员，请修改后再进行汇出或执行微调']: 'Vui lòng điều chỉnh nội dung cuối cùng của văn bản để nhân vật là AI hoặc nhân viên hỗ trợ khách hàng trước khi xuất bản hoặc thực hiện điều chỉnh.',
	['批量加入微调']: 'Thêm điều chỉnh hàng loạt',
	['自定加入微调的名称']: 'Tùy chỉnh thêm tên tinh chỉnh',
	['微调名称']: 'Điều chỉnh tên',
	['请输入微调的名称']: 'Vui lòng nhập tên tinh chỉnh',
	['微调的名称']: 'Tên gọi của việc tinh chỉnh',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔']: 'Vui lòng xác nhận có xóa hàng loạt hay không (tổng cộng {{selectedFineTuningRecordsLength}} giao dịch',
	['已取消']: 'Đã bị hủy',
	['取消微调']: 'Hủy điều chỉnh',
	['取消微调成功']: 'Hủy điều chỉnh thành công',
	['取消此笔客服系统微调训练时，需要同时取消对应的 OpenAI 后台微调训练。只有两者均取消后，微调训练才会被完整移除。请确认是否要取消此客服系统微调训练？']: 'Khi hủy bỏ việc điều chỉnh hệ thống dịch vụ khách hàng này, cần hủy bỏ đồng thời việc điều chỉnh nền tảng OpenAI tương ứng. Chỉ khi cả hai đều được hủy bỏ, việc điều chỉnh mới sẽ được loại bỏ hoàn toàn. Xin xác nhận xem bạn có muốn hủy bỏ việc điều chỉnh hệ thống dịch vụ khách hàng này không?',
	['复制快捷语成功']: 'Sao chép văn bản nhanh thành công',
	['复制常用图片成功']: 'Sao chép hình ảnh thông dụng thành công',
	['左侧']: 'bên trái',
	['右侧']: 'bên phải',
	['{{text}}正在服务{{total}}则对话']: '{{text}} đang phục vụ {{total}} cuộc đối thoại',
	['新增跑马灯成功']: 'Thêm marquee thành công',
	['修改跑马灯成功']: 'Sửa đèn hiệu thành công',
	['刪除跑马灯成功']: 'Xóa marquee thành công',
	['启用跑马灯成功']: 'Kích hoạt đèn chạy chữ thành công',
	['停用跑马灯成功']: 'Tắt đèn chạy chữ thành công',
	['对象栏位']: 'Đối tượng栏位',
	['显示跑马灯内容']: 'Hiển thị nội dung đèn chạy chữ',
	['请确认是否启用跑马灯？']: 'Vui lòng xác nhận có bật đèn chạy không?',
	['请确认是否停用跑马灯？']: 'Vui lòng xác nhận có ngừng sử dụng đèn nhấp nháy không?',
	['请确认是否删除跑马灯？']: 'Xin hãy xác nhận có xóa đèn chạy không?',
	['{{text}}最多{{inputLimit}}组']: '{{text}} tối đa {{inputLimit}} nhóm',
	['数值范围']: 'phạm vi giá trị',
	['数值不能为空']: 'Giá trị không được để trống.',
	['数值']: 'giá trị',
	['请输入数字']: 'Vui lòng nhập số',
	['输入多组文字请用, 区隔']: 'Nhập nhiều nhóm văn bản, vui lòng phân cách bằng dấu phẩy.',
	['当用户符合对象设定名称及栏位规则中的内容时，才会生效跑马灯推广']: 'Khi người dùng phù hợp với nội dung trong quy định tên và cột của đối tượng, thì hiệu ứng quảng cáo marquee mới có hiệu lực.',
	['新增跑马灯']: 'Thêm đèn nhấp nháy',
	['对象栏位不能为空']: 'Cột đối tượng không được để trống',
	['请输入对象栏位']: 'Vui lòng nhập mục đối tượng',
	['栏位规则']: 'Quy tắc cột',
	['栏位规则不能为空']: 'Cột không được để trống',
	['请选择栏位规则']: 'Vui lòng chọn quy tắc cột',
	['开头图示']: 'Hình minh họa đầu tiên',
	['开头图示不能为空']: 'Hình ảnh đầu tiên không được để trống',
	['请选择开头图示']: 'Vui lòng chọn hình ảnh bắt đầu',
	['跑马灯内容']: 'Nội dung đèn chạy',
	['修改跑马灯']: 'Chỉnh sửa đèn nhấp nháy',
	['变更的平台设定将同步套用至下级角色，是否确认修改？']: 'Thay đổi cài đặt nền tảng sẽ được áp dụng đồng bộ cho các vai trò cấp dưới, bạn có xác nhận chỉnh sửa không?',
	['确认要删除[个人/公共]常用图片[{{title}}]吗？']: 'Bạn có chắc chắn muốn xóa hình ảnh thường dùng [cá nhân/công cộng] [{{title}}] không?',
	['一经确认删除无法复原。']: 'Một khi xác nhận xóa, sẽ không thể khôi phục.',
	['客服日志']: 'Nhật ký dịch vụ khách hàng',
	['请输入内容等关键字']: 'Vui lòng nhập nội dung và từ khóa quan trọng',
	['确认要删除[个人/公共]快捷语[{{title}}]：[{{content}}]吗？']: 'Xác nhận có muốn xóa [cá nhân/công cộng] cụm từ tắt [{{title}}]: [{{content}}] không?',
	['没有其他进入标签被开启，故无法关闭此进入标签']: 'Không có thẻ vào khác được mở, vì vậy không thể đóng thẻ vào này.',
	['没有其他进入标签被开启，故无法删除此标签']: 'Không có nhãn khác nào được mở, vì vậy không thể xóa nhãn này.',
	['所有人']: 'Tất cả mọi người',
	['自定义对象']: 'Đối tượng tùy chỉnh',
	['套用对象']: 'Đối tượng áp dụng',
	['回主画面']: 'Về trang chủ',
	['孟加拉语']: 'tiếng Bengal',
	['繁体中文']: 'chinese phồn thể',
	['简体中文']: 'Tiếng Trung giản thể',
	['韩语']: 'Tiếng Hàn',
	['日语']: 'tiếng Nhật',
	['葡萄牙语']: 'tiếng Bồ Đào Nha',
	['印地语']: 'Tiếng Ấn Độ',
	['俄语']: 'tiếng Nga',
	['重要资讯']: 'Thông tin quan trọng',
	['在对话中切换语言，在某些情况下，可能导致讯息翻译功能延迟约 10 分钟，影响新旧讯息的读取。确定要切换语言?']: 'Trong việc chuyển đổi ngôn ngữ trong cuộc trò chuyện, trong một số trường hợp, có thể dẫn đến chức năng dịch tin nhắn bị trì hoãn khoảng 10 phút, ảnh hưởng đến việc đọc tin nhắn cũ và mới. Bạn có chắc chắn muốn chuyển đổi ngôn ngữ không?',
	['暂无对话']: 'Chưa có cuộc trò chuyện',
	['档案上传中']: 'Đang tải tệp lên',
	['{{name}} 已于 {{time}} 开启自动推播']: '{{name}} đã bắt đầu tự động phát sóng vào {{time}}',
	['{{name}} 已于 {{time}} 关闭自动推播']: '{{name}} đã tắt thông báo tự động vào {{time}}',
	['商户代码']: 'Mã thương nhân',
	['请输入商户代码']: 'Vui lòng nhập mã thương nhân',
	['密钥']: 'Khóa bí mật',
	['请输入密钥']: 'Vui lòng nhập khóa bí mật',
	['共同设定']: 'Cài đặt chung',
	['充值未到帐设定']: 'Cài đặt nạp tiền chưa đến',
	['出款未到帐设定']: 'Cài đặt rút tiền chưa đến',
	['确认进行储存？']: 'Xác nhận lưu?',
	['SKILL开关']: 'Bật/Tắt SKILL',
	['请输入SKILL']: 'Nhập SKILL',
	['派单 API 参数']: 'Tham số API phân công đơn',
	['请输入派单API URL']: 'Nhập URL API phân công đơn',
	['开单者username']: 'Tên người tạo đơn',
	['请输入开单者username']: 'Nhập tên người tạo đơn',
	['频道名称']: 'Tên kênh',
	['请输入频道名称']: 'Nhập tên kênh',
	['开单原因']: 'Lý do tạo đơn',
	['请输入开单原因']: 'Nhập lý do tạo đơn',
	['充值订单查询 API URL']: 'URL API truy vấn đơn nạp tiền',
	['出款订单查询 API URL']: 'URL API truy vấn đơn rút tiền',
	['同义词设定']: 'Thiết lập từ đồng nghĩa',
	['开启BM25']: 'Bật BM25',
	['同义词']: 'từ đồng nghĩa',
	['更新时间']: 'Cập nhật thời gian',
	['批次新增同义词']: 'Thêm từ đồng nghĩa theo lô',
	['修改同义词']: 'Sửa đổi từ đồng nghĩa',
	['新增同义词']: 'Thêm từ đồng nghĩa',
	['请输入同义词，使用逗号区隔不同词汇']: 'Vui lòng nhập từ đồng nghĩa, sử dụng dấu phẩy để phân tách các từ khác nhau.',
	['请以逗号区隔不同词汇，用分号区隔不同组同义词']: 'Xin vui lòng phân cách các từ khác nhau bằng dấu phẩy, phân cách các nhóm từ đồng nghĩa bằng dấu chấm phẩy.',
	['输入格式说明：']: 'Hướng dẫn định dạng đầu vào:',
	['请用，区隔不同词汇，例如：充值,储值,入金,课金']: 'nạp tiền, gửi tiền',
	['词汇与标点符号前后不要出现空白']: 'Từ vựng và dấu câu không được xuất hiện khoảng trắng trước và sau.',
	['请用；或分行(enter)区隔同组同义词，例如：']: 'Vui lòng sử dụng dấu chấm phẩy hoặc xuống dòng (enter) để phân cách các từ đồng nghĩa trong cùng một nhóm, ví dụ:',
	['充值,储值,入金,课金']: 'Nạp tiền',
	['log in,登入;亲,宝贝']: 'đăng nhập, thân yêu',
	['请输入同义词']: 'Vui lòng nhập từ đồng nghĩa',
	['同义词不可为空']: 'Từ đồng nghĩa không được để trống',
	['同义词格式有误']: 'Định dạng đồng nghĩa không chính xác',
	['同义词不可有特殊字元']: 'Từ đồng nghĩa không được có ký tự đặc biệt',
	['字元不可超过10000']: 'Ký tự không được vượt quá 10000',
	['需至少输入两个词汇']: 'Cần nhập tối thiểu hai từ vựng.',
	['删除同义词']: 'Xóa đồng nghĩa',
	['请确认是否删除同义词？']: 'Xin vui lòng xác nhận có xóa từ đồng nghĩa không?',
	['新增同义词成功']: 'Thêm đồng nghĩa thành công',
	['新增同义词失败']: 'Thêm từ đồng nghĩa thất bại',
	['修改同义词成功']: 'Chỉnh sửa từ đồng nghĩa thành công',
	['修改同义词失败']: 'Thay đổi từ đồng nghĩa không thành công',
	['删除同义词成功']: 'Xóa thành công từ đồng nghĩa',
	['删除同义词失败']: 'Xóa từ đồng nghĩa thất bại',
	['内容有重复字']: 'Nội dung có chữ bị trùng lặp',
	['新增图片，详细图片请参考公告管理']: 'Thêm hình ảnh, vui lòng tham khảo quản lý thông báo để biết thêm chi tiết.',
	['目前只支援ChatGPT进行微调训练']: 'Hiện tại chỉ hỗ trợ ChatGPT để tinh chỉnh đào tạo.',
	['AI系列']: 'Dòng AI',
	['AI系列不能为空']: 'Dòng AI không được để trống',
	['启用ChatGPT']: 'Kích hoạt ChatGPT',
	['启用Gemini']: 'Kích hoạt Gemini',
	['AI客服']: 'AI chăm sóc khách hàng',
	['ID入口']: 'Cổng ID',
	['IP']: 'IP',
	['USER ID']: 'ID người dùng',
	['{{itemLabel}}內容不可为空']: 'Nội dung {{itemLabel}} không được để trống',
	['{{text}}仅能输入数字']: '{{text}} chỉ có thể nhập số',
	['{{text}}最多{{limit}}个字元']: '{{text}} tối đa {{limit}} ký tự',
	['{{text}}最多數字{{limit}}碼']: '{{text}} tối đa {{limit}} chữ số',
	['{{time}}分']: '{{time}} phút',
	['{{time}}时']: '{{time}} giờ',
	['{{time}}秒']: '{{time}} giây',
	['上一则发送后等待时间']: 'Thời gian chờ sau khi gửi tin nhắn trước.',
	['上传图片']: 'Tải lên hình ảnh',
	['主要API keys']: 'Khóa API chính',
	['主要语言']: 'Ngôn ngữ chính',
	['事件']: 'sự kiện',
	['以查看预览效果']: 'Để xem hiệu ứng xem trước',
	['依照选择模组设定UI显示位置及功能。']: 'Theo mô-đun đã chọn, xác định vị trí hiển thị và chức năng của UI.',
	['依照选择的风格进行调整配色（含背景、框体、配色、线条感）。']: 'Điều chỉnh màu sắc theo phong cách đã chọn (bao gồm nền, khung, màu sắc, cảm giác đường nét).',
	['修改帐号履历成功']: 'Chỉnh sửa hồ sơ tài khoản thành công',
	['修改翻译API成功']: 'Sửa đổi API dịch thuật thành công',
	['充值帐号']: 'Nạp tài khoản',
	['共 {{numOfItems}} 笔']: 'Tổng cộng {{numOfItems}} giao dịch',
	['关 闭']: 'Đóng',
	['关闭后，整个推播系统将停止运作，所有推播讯息会暂时无效。您随时可以重新开启。']: 'Sau khi tắt, toàn bộ hệ thống thông báo sẽ ngừng hoạt động, tất cả thông báo sẽ tạm thời không có hiệu lực. Bạn có thể bật lại bất cứ lúc nào.',
	['内容最多20字元']: 'Nội dung tối đa 20 ký tự',
	['内容预览']: 'Nội dung xem trước',
	['切换后，跑马灯文字与快捷键可能会出现显示不清晰或对比度不足的情况，需到后台进行重新设定']: 'Sau khi chuyển đổi, văn bản marquee và phím tắt có thể xuất hiện tình trạng hiển thị không rõ ràng hoặc độ tương phản không đủ, cần vào backend để thiết lập lại.',
	['删除履历']: 'Xóa hồ sơ',
	['删除帐号履历成功']: 'Xóa lịch sử tài khoản thành công',
	['删除跑马灯']: 'Xóa đèn nháy',
	['加载中...']: 'Đang tải...',
	['勾选后，该账号在联系客服时，账号名称旁会显示']: 'Khi đánh dấu, tên tài khoản sẽ hiển thị bên cạnh khi liên hệ với bộ phận hỗ trợ khách hàng.',
	['即时预览']: 'Xem trước tức thì',
	['取消新增微调文本']: 'Hủy thêm văn bản tinh chỉnh',
	['古典深色风格']: 'Phong cách tối cổ điển',
	['單次']: 'một lần',
	['回传表单']: 'Biểu mẫu trả lại',
	['外观风格']: 'Phong cách ngoại hình',
	['客户端视觉设定']: 'Thiết lập hình ảnh của khách hàng',
	['客户端视觉设定成功']: 'Cài đặt giao diện khách hàng thành công',
	['尚无资料']: 'Chưa có dữ liệu',
	['展开']: 'Mở rộng',
	['履历数量']: 'Số lượng hồ sơ',
	['帐号履历']: 'Tài khoản lịch sử',
	['帐号履历管理']: 'Quản lý lịch sử tài khoản',
	['平台代码不能有空白']: 'Mã nền tảng không được có khoảng trắng.',
	['平台代码仅能输入英文和数字']: 'Mã nền tảng chỉ có thể nhập tiếng Anh và số.',
	['平台代码最多5码']: 'Mã nền tảng tối đa 5 ký tự',
	['平台代码最少2码']: 'Mã nền tảng tối thiểu 2 mã',
	['平台语言']: 'Ngôn ngữ nền tảng',
	['平均首次工作时间']: 'Thời gian làm việc lần đầu trung bình',
	['建立者']: 'người sáng lập',
	['开关']: 'Công tắc',
	['快速通道']: 'Làn đường nhanh',
	['手动推播']: 'Đẩy tay',
	['手机版']: 'Phiên bản di động',
	['批量删除']: 'Xóa hàng loạt',
	['排序']: 'sắp xếp',
	['推播功能']: 'Chức năng đẩy',
	['推播功能 OFF：推播功能关闭整个系统不运作，列表中的所有策略都无效。']: 'Chức năng thông báo OFF: Chức năng thông báo tắt, toàn bộ hệ thống không hoạt động, tất cả các chiến lược trong danh sách đều không có hiệu lực.',
	['推播时间']: 'Thời gian thông báo',
	['推播讯息列表']: 'Danh sách thông báo đẩy',
	['推播设定']: 'Cài đặt đẩy',
	['操作内容']: 'Nội dung thao tác',
	['收起']: 'Thu lại',
	['数值/内容']: 'Giá trị/Nội dung',
	['数值/内容不可为空']: 'Giá trị/nội dung không được để trống',
	['数值只能输入数字、负号、小数点']: 'Giá trị chỉ có thể nhập số, dấu âm, dấu phẩy.',
	['数值小数最多6位数']: 'Giá trị thập phân tối đa 6 chữ số',
	['数值整数最多15位']: 'Giá trị số nguyên tối đa 15 chữ số',
	['新增履历']: 'Thêm hồ sơ',
	['新增帐号履历成功']: 'Thêm tài khoản thành công',
	['新增类型']: 'Thêm loại',
	['无工作']: 'Không có việc làm',
	['时间设定需至少为 3 分钟']: 'Thời gian thiết lập ít nhất phải là 3 phút',
	['是否修改翻译API?']: 'Có sửa đổi API dịch không?',
	['更新成功']: 'Cập nhật thành công',
	['更新者']: 'Người cập nhật',
	['架构模组']: 'Mô-đun kiến trúc',
	['栏位名称']: 'Tên cột',
	['栏位类型']: 'Loại cột',
	['栏位类型不可为空']: 'Loại cột không thể để trống',
	['档案格式不符']: 'Định dạng tệp không đúng',
	['PDF文件']: 'Tài liệu PDF',
	['模式与间隔时间']: 'Chế độ và khoảng thời gian',
	['欢迎回来']: 'Chào mừng trở lại',
	['此操作将自动翻译其他语言，原有输入内容将被翻译结果覆盖，请确认是否继续？']: 'Hành động này sẽ tự động dịch sang các ngôn ngữ khác, nội dung nhập ban đầu sẽ bị kết quả dịch thay thế, vui lòng xác nhận xem có tiếp tục không?',
	['汇入']: 'Nhập khẩu',
	['汇入微调文本成功']: 'Nhập văn bản điều chỉnh thành công',
	['汇出微调文本成功']: 'Xuất khẩu văn bản tinh chỉnh thành công',
	['清空翻译']: 'Xóa hết dịch',
	['所有语系内容皆填写完成后才可确定，可使用自动翻译补齐其余语系']: 'Cần hoàn tất nội dung của tất cả ngôn ngữ trước khi xác nhận. Có thể dùng dịch tự động để điền các ngôn ngữ còn lại.',
	['标题与内容皆需填写才可自动翻译']: 'Cần điền cả tiêu đề và nội dung trước khi dịch tự động.',
	['状态持续时间']: 'Thời gian trạng thái',
	['用户帐号']: 'Tài khoản người dùng',
	['用户帐号不能为空']: 'Tài khoản người dùng không được bỏ trống',
	['电脑版']: 'Phiên bản máy tính',
	['目前无适用推播']: 'Hiện tại không có thông báo nào phù hợp.',
	['目前有启用中的侦测语言平台，无法关闭']: 'Hiện tại có nền tảng phát hiện ngôn ngữ đang được sử dụng, không thể tắt.',
	['确定删除IP白名单？']: 'Xác nhận xóa danh sách trắng IP?',
	['确定发送推播？']: 'Xác nhận gửi thông báo?',
	['确定要关闭推播功能吗？']: 'Bạn có chắc chắn muốn tắt tính năng thông báo không?',
	['确认删除此笔履历?']: 'Xác nhận xóa bản ghi này?',
	['确认要删除推播讯息？']: 'Xác nhận có muốn xóa thông báo đẩy không?',
	['立即登入']: 'Đăng nhập ngay lập tức',
	['第 {{min}} - {{max}} 笔/共 {{numOfItems}} 笔']: 'Thứ {{min}} - {{max}} mục/ Tổng cộng {{numOfItems}} mục',
	['筛选条件']: 'Điều kiện lọc',
	['类型名称']: 'Loại tên',
	['系统预设模组']: 'Hệ thống mô-đun được thiết lập sẵn',
	['经典浅色风格']: 'Phong cách sáng màu cổ điển',
	['翻译API']: 'API dịch',
	['聊天介面']: 'Giao diện trò chuyện',
	['自动推播']: 'Thông báo tự động',
	['自动推播功能']: 'Chức năng thông báo tự động',
	['自动推播功能 OFF：列表中的所有推播讯息虽然仍可被客服手动执行，但所有计时器功能停止运作。']: 'Tính năng tự động đẩy thông báo TẮT: Tất cả thông báo trong danh sách vẫn có thể được nhân viên phục vụ thực hiện bằng tay, nhưng tất cả chức năng hẹn giờ sẽ ngừng hoạt động.',
	['自定义']: 'Tùy chỉnh',
	['自定义文案']: 'Tùy chỉnh nội dung',
	['自客服接起对话后开始计算']: 'Sau khi bộ phận dịch vụ khách hàng bắt đầu cuộc trò chuyện, sẽ bắt đầu tính toán.',
	['该类型目前有推播讯息套用中，无法删除']: 'Loại này hiện đang có thông báo đẩy áp dụng, không thể xóa.',
	['详细说明']: 'Chi tiết',
	['请先选择推播类型']: 'Vui lòng chọn loại thông báo trước.',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔)？']: 'Xin vui lòng xác nhận có muốn xóa hàng loạt không (tổng cộng {{selectedFineTuningRecordsLength}} lần)？',
	['请输入事件']: 'Vui lòng nhập sự kiện',
	['请输入会员ID']: 'Nhập ID thành viên',
	['请输入內容']: 'Vui lòng nhập nội dung',
	['请输入关键字']: 'Nhập từ khóa',
	['请输入您的会员 ID 以继续']: 'Vui lòng nhập ID hội viên của bạn để tiếp tục',
	['请输入数值/内容']: 'Nhập số liệu/nội dung',
	['请输入文字']: 'Vui lòng nhập văn bản',
	['请输入栏位名称']: 'Vui lòng nhập tên cột',
	['请输入用户帐号']: 'Vui lòng nhập tài khoản người dùng',
	['请输入类型名称']: 'Vui lòng nhập tên loại.',
	['请输入详细说明']: 'Vui lòng nhập mô tả chi tiết',
	['请选择上方下拉选单']: 'Vui lòng chọn từ menu thả xuống ở trên.',
	['请选择主要语言自动翻译']: 'Xin hãy chọn ngôn ngữ chính để dịch tự động.',
	['请选择帐号状态']: 'Vui lòng chọn trạng thái tài khoản',
	['请选择平台']: 'Vui lòng chọn nền tảng',
	['请选择推播项目']: 'Vui lòng chọn mục thông báo',
	['请选择栏位类型']: 'Vui lòng chọn loại cột',
	['请选择类型']: 'Vui lòng chọn loại',
	['请选择类型与项目(标题)以预览内容']: 'Vui lòng chọn loại và mục (tiêu đề) để xem trước nội dung.',
	['请选择表单选项']: 'Vui lòng chọn tùy chọn biểu mẫu',
	['请选择运算规则']: 'Vui lòng chọn quy tắc tính toán',
	['请选择预览画面']: 'Vui lòng chọn màn hình xem trước',
	['跑马灯设定']: 'Cài đặt đèn chạy',
	['轮播']: 'bảng quay',
	['轮播模式']: 'Chế độ băng chuyền',
	['轮播间隔时间']: 'Thời gian trượt tuyến',
	['运算规则']: 'Quy tắc tính toán',
	['运算规则不可为空']: 'Quy tắc tính toán không được để trống',
	['返回上一层']: 'Quay lại lớp trước',
	['返回上一页']: 'Trở về trang trước',
	['送出推播']: 'Gửi thông báo',
	['选单介面']: 'Giao diện menu',
	['选择推播类型']: 'Chọn loại thông báo',
	['选择推播项目(标题)']: 'Chọn mục thông báo (tiêu đề)',
	['通知时间']: 'Thời gian thông báo',
	['通知时间不能为空']: 'Thời gian thông báo không được để trống',
	['重新产生Key/IV']: 'Tạo lại Key/IV',
	['重要客户']: 'Khách hàng quan trọng',
	['需为1~60正整数']: 'Cần là số nguyên dương từ 1 đến 60',
	['预估时间']: 'Thời gian ước tính',
	['预览图片']: 'Xem trước hình ảnh',
	['首次工作时间报表']: 'Bảng báo cáo thời gian làm việc đầu tiên',
	['日志管理']: 'Quản lý nhật ký',
	['API传送日志']: 'Nhật ký truyền API',
	['订单号']: 'Số đơn hàng',
	['三方单号']: 'Số đơn bên thứ ba',
	['请输入订单号']: 'Vui lòng nhập số đơn hàng',
	['请输入三方单号']: 'Vui lòng nhập số đơn bên thứ ba',
	['充值订单查询']: 'Truy vấn đơn nạp tiền',
	['出款订单查询']: 'Truy vấn đơn rút tiền',
	['开派单']: 'Tạo đơn phái',
	['传送派单信息']: 'Gửi thông tin phái đơn',
	['CS传送资料']: 'Dữ liệu CS gửi',
	['平台回覆资料']: 'Dữ liệu nền tảng trả lời',
	['{{text}}需以{{prefix}}开头']: '{{-text}} phải bắt đầu bằng {{-prefix}}',
	['系统通知']: 'Thông báo hệ thống',
	['派单传送讯息']: 'Gửi tin nhắn phái đơn',
	['派单传送档案']: 'Gửi tệp phái đơn',
	['请输入平台']: 'Vui lòng nhập nền tảng',
	['派单讯息润饰设定']: 'Cài đặt chỉnh sửa tin nhắn phái đơn',
	['此指令不会载入「AI共同设定」与「平台AI设定」，为独立的 Agent 使用']: 'Lệnh này không tải "Cài đặt chung AI" và "Cài đặt nền tảng AI", được sử dụng như một Agent độc lập',
	['用户个人设定']: 'Cài đặt cá nhân người dùng',
	['新增用户个人资讯']: 'Thêm thông tin cá nhân người dùng',
	['个人资讯参数名称']: 'Tên tham số thông tin cá nhân',
	['请输入个人资讯参数名称']: 'Vui lòng nhập tên tham số thông tin cá nhân',
	['*新增多个请使用逗号「 , 」隔开']: '*Thêm nhiều mục vui lòng phân tách bằng dấu phẩy「 , 」',
	['用来设定该平台哪些个人资讯要丢给AI，只有设定在「用户个人设定」的参数，才会传送给AI']: 'Dùng để thiết lập thông tin cá nhân nào của nền tảng sẽ gửi cho AI, chỉ những tham số được thiết lập trong "Cài đặt cá nhân người dùng" mới được gửi cho AI',
	['批次删除用户个人资讯']: 'Xóa hàng loạt thông tin cá nhân người dùng',
	['确定要批次删除用户个人资讯吗？']: 'Bạn có chắc muốn xóa hàng loạt thông tin cá nhân người dùng không?',
	['个人资讯参数名称不能为空']: 'Tên tham số thông tin cá nhân không được để trống',
	['已存在「{{name}}」']: '「{{-name}}」đã tồn tại',
	['最多可新增{{limit}}个，已超过上限']: 'Tối đa có thể thêm {{-limit}} mục, đã vượt quá giới hạn',
	['新增用户个人资讯成功']: 'Thêm thông tin cá nhân người dùng thành công',
	['新增用户个人资讯失败']: 'Thêm thông tin cá nhân người dùng thất bại',
	['删除用户个人资讯成功']: 'Xóa thông tin cá nhân người dùng thành công',
	['删除用户个人资讯失败']: 'Xóa thông tin cá nhân người dùng thất bại',
	['图像管理']: 'Quản lý hình ảnh',
	['自定义图像']: 'Hình ảnh tùy chỉnh',
	['档案格式：“PNG、JPG”档案大小不得大于 500KB']: 'Định dạng tệp: "PNG, JPG", kích thước tệp không được vượt quá 500KB',
	['档案最大500K']: 'Tệp tối đa 500K',
	['新增图像成功']: 'Thêm hình ảnh thành công',
	['删除图像成功']: 'Xóa hình ảnh thành công',
	['是否确定删除图像？']: 'Bạn có chắc chắn muốn xóa hình ảnh này không?',
	['内容设定']: 'Thiết lập nội dung',
	['英语']: 'Tiếng Anh',
	['{{language}}内容']: 'Nội dung {{language}}',
	['请输入{{language}}内容']: 'Vui lòng nhập nội dung {{language}}',
	['请选择时间']: 'Vui lòng chọn thời gian',
	['请选择公司']: 'Vui lòng chọn công ty',
	['请输入{{label}}']: 'Vui lòng nhập {{label}}',
	['原文参考（{{language}}）']: 'Tham khảo văn bản gốc ({{language}})',
	['确定清空设定吗？']: 'Bạn có chắc chắn muốn xóa cài đặt không?',
	['确定取消设定吗？']: 'Bạn có chắc chắn muốn hủy cài đặt không?',
	['{{language}}{{tab}}']: '{{language}} {{tab}}',
	['未完成']: 'Chưa hoàn thành',
	['{{language}}{{label}}超过{{limit}}字']: '{{label}} của {{language}} vượt quá {{limit}} ký tự',
	['公告标题']: 'Tiêu đề thông báo',
	['进线IP']: 'IP kết nối',
	['请输入进线IP']: 'Vui lòng nhập IP kết nối',
	['模型切换：{{fromModel}} -> {{toModel}}']: 'Chuyển mô hình: {{fromModel}} -> {{toModel}}',
	['包网后台删除帐号后，客服系统帐号将同步删除']: 'Sau khi xóa tài khoản trong hệ thống quản trị BW, tài khoản hệ thống CSKH sẽ bị xóa đồng bộ',
	['系统已有新版本，请重新整理']: 'Đã có phiên bản mới, vui lòng làm mới lại',
	['页面加载失败，请重试']: 'Tải trang thất bại, vui lòng thử lại',
	['翻译中']: 'Đang dịch',
	['监控与即时摘要设定']: 'Cài đặt giám sát và tóm tắt tức thời',
	['批量转接']: 'Chuyển tiếp hàng loạt',
	['已选 {{count}} 则对话']: 'Đã chọn {{count}} cuộc trò chuyện',
	['勾选']: 'Chọn',
	['全平台服务人数']: 'Số người phục vụ toàn nền tảng',
	['未开启{{platform}}平台']: 'Chưa bật nền tảng {{-platform}}',
	['成功由 {{inviter}} 转接至 {{invitee}}，共 {{count}} 则']: 'Chuyển giao thành công từ {{-inviter}} đến {{-invitee}}, tổng cộng {{count}}.',
	['接受']: 'Chấp nhận',
	['拒绝({{seconds}}S)']: 'Từ chối({{seconds}}S)',
	['生成链接']: 'Tạo liên kết',
	['链接生成中...']: 'Đang tạo liên kết...',
	['复制链接']: 'Sao chép liên kết',
	['已复制链接']: 'Đã sao chép liên kết',
	['档案上传失败']: 'Tải tệp lên thất bại',
	['转档失败，请重新上传']: 'Chuyển đổi thất bại, vui lòng tải lên lại',
	['人工回复']: 'Trả lời thủ công',
	['检视回复']: 'Xem trả lời',
	['{{time}} AI 拦截对话']: '{{time}} AI đã chặn hội thoại',
	['AI 拦截原因与人工回复']: 'Lý do AI chặn và trả lời thủ công',
	['人工回复失败']: 'Trả lời thủ công thất bại',
	['回复讯息']: 'Tin nhắn trả lời',
	['对话摘要']: 'Tóm tắt hội thoại',
	['建议回复']: 'Trả lời đề xuất',
	['拦截原因']: 'Lý do chặn',
	['拦截回复']: 'Trả lời bị chặn',
	['确定送出']: 'Xác nhận gửi',
	['生成链接失败']: 'Tạo liên kết không thành công',
	['连接超时，请稍后再试']: 'Kết nối hết thời gian chờ, vui lòng thử lại sau',
	['上一则']: 'Trước',
	['下一则']: 'Tiếp theo',
	['重新传送']: 'Gửi lại',
	['传送中...']: 'Đang gửi...',
	['用户端翻译失败']: 'Dịch sang phía người dùng thất bại',
	['重新传送失败']: 'Gửi lại thất bại',
	['请确认是否删除以下模型？']: 'Xác nhận xóa mô hình sau đây?',
	['新增模型']: 'Thêm mô hình',
	['请选择AI系列']: 'Vui lòng chọn dòng AI',
	['支援模型']: 'Mô hình được hỗ trợ',
	['支援模型不能为空']: 'Mô hình được hỗ trợ không được để trống',
	['请选择支援模型']: 'Vui lòng chọn mô hình được hỗ trợ',
	['AI模型管理']: 'Quản lý mô hình AI',
	['模型不能为空']: 'Mô hình không được để trống',
	['请选择模型']: 'Vui lòng chọn mô hình',

	['对话类型']: 'Loại hội thoại',
	['单纯AI讯息']: 'Chỉ có thông điệp AI',
	['单纯人员讯息']: 'Chỉ có thông điệp nhân viên',
	['人员+AI讯息']: 'Thông điệp nhân viên + AI',
	['是否经过AI拦截']: 'Có bị AI chặn không',
	['是否修改AI拦截建议回覆']: 'Có sửa nội dung trả lời AI đề xuất không',
	['监控API keys']: 'Khóa API giám sát',
	['管理']: 'Quản lý',

	['启用显性快取']: 'Bật bộ nhớ đệm tường minh',
	['AI监控拦截总量']: 'Tổng số lượt AI giám sát chặn',
	['AI监控拦截']: 'AI giám sát chặn',
	['有修改建议回覆总量']: 'có sửa trả lời đề xuất',
	['触发关键字：{{keywords}}。']: 'Từ khóa được kích hoạt: {{-keywords}}.',

	['版面已套用，但尚未同步至帐号']: 'Đã áp dụng bố cục nhưng chưa đồng bộ với tài khoản',
	['服务器重设失败，下次开启工作区时会再同步']: 'Đặt lại trên máy chủ thất bại, sẽ đồng bộ lại vào lần mở không gian làm việc tiếp theo',
	['浏览器无法储存版面，离开前请确认帐号同步完成']: 'Trình duyệt không thể lưu bố cục, vui lòng đảm bảo đã đồng bộ với tài khoản trước khi rời đi',

	['重设版面配置']: 'Đặt lại bố cục',
	['确定要将版面配置回复为系统预设吗？']: 'Bạn có chắc muốn khôi phục bố cục về mặc định của hệ thống?',
	['客服支援语言']: 'Ngôn ngữ hỗ trợ CSKH',
	['请选择支援语言']: 'Vui lòng chọn ngôn ngữ hỗ trợ',
	['请选择客服支援语言']: 'Vui lòng chọn ngôn ngữ hỗ trợ CSKH',

	['删除平台']: 'Xóa nền tảng',
	['是否确定删除{{code}}平台']: 'Bạn có chắc muốn xóa nền tảng {{-code}}?',
	['删除{{code}}平台成功']: 'Xóa nền tảng {{-code}} thành công',
	['上传图片或PDF']: 'Tải lên hình ảnh hoặc PDF',
	['当前平台维护中，如有疑问请联系管理员']: 'Nền tảng hiện tại đang bảo trì, nếu có thắc mắc vui lòng liên hệ quản trị viên.',
	['当前平台已禁用，如有疑问请联系管理员']: 'Nền tảng hiện tại đã bị vô hiệu hóa, nếu có thắc mắc vui lòng liên hệ quản trị viên.',
	['收回提示文字']: 'Văn bản nhắc nhở thu hồi',
	['请输入提示文字，例如：抱歉亲 妹子发错了更正一下哦！']: 'Vui lòng nhập nội dung nhắc, ví dụ: Xin lỗi bạn ơi, tôi gửi nhầm tin nhắn, vui lòng sửa lại!',
	['标签名称']: 'Tên nhãn',
	['预览失败']: 'Xem trước thất bại',
	['放大']: 'Phóng to',
	['缩小']: 'Thu nhỏ',
	['上一页']: 'Trang trước',
	['下一页']: 'Trang sau',
	['点击预览']: 'Nhấp để xem trước',
};
